/** AUTO-GENERATED FROM capabilities.spec.yaml — DO NOT EDIT MANUALLY. Run pnpm codegen:capabilities to regenerate. */
/**
 * Catálogo de capabilities core — Fatia A foundational.
 *
 * ~30 capabilities extraídas de ADR-046 (domínios core, ai-basic,
 * structure, extended-basic) + algumas mencionadas explicitamente no
 * OpenAPI v1 (Capability.yaml exemplos, capability-registry.yaml +
 * feature-flags.yaml x-lume-capability hints).
 *
 * Capabilities de fatias verticais (Bonds, Documents, Checklists, Bubbles,
 * etc.) entram em fichas próprias. A consistência banco↔código será
 * validada em CI nas fatias seguintes.
 *
 * Fontes:
 *   - ADR-046 "Configuração técnica de capabilities" (DECISIONS.md §3253).
 *   - Capability.yaml — schema + exemplo `bond-create`.
 *   - capability-registry.yaml — x-lume-capability `capability-registry-read/manage`.
 *   - feature-flags.yaml — x-lume-capability `tenant-config-read/manage`.
 *   - capabilities.yaml — x-lume-capability `lume-internal-capability-management`.
 *   - ADR-094 — `silent-monitoring` exemplo de capability granular User.
 */
export const CAPABILITY_CATALOG = [
    // ─── Domínio core (5) ──────────────────────────────────────────────────
    {
        code: 'core-authentication',
        tierMin: 'solo',
        description: 'Autenticação básica (login + senha + MFA opcional).',
        auditSeverity: 'info',
        category: 'authentication',
        appliesTo: 'tenant',
    },
    {
        code: 'core-conversation',
        tierMin: 'solo',
        description: 'Operação fundamental de conversas.',
        auditSeverity: 'info',
        category: 'conversation',
        appliesTo: 'tenant',
    },
    {
        code: 'core-multi-tenant',
        tierMin: 'solo',
        description: 'Isolamento multi-tenant absoluto.',
        auditSeverity: 'info',
        category: 'admin',
        appliesTo: 'tenant',
    },
    {
        code: 'core-multi-channel-whatsapp',
        tierMin: 'solo',
        description: 'Canal WhatsApp Cloud API.',
        auditSeverity: 'info',
        category: 'conversation',
        appliesTo: 'tenant',
    },
    {
        code: 'audit-basic',
        tierMin: 'solo',
        description: 'Audit log básico (eventos críticos).',
        auditSeverity: 'info',
        category: 'audit',
        appliesTo: 'tenant',
    },
    // ─── Domínio ai-basic (6) ──────────────────────────────────────────────
    {
        code: 'ai-suggestion-h-a',
        tierMin: 'solo',
        description: 'Modo H_a — IA sugere, humano dirige.',
        auditSeverity: 'info',
        category: 'ai',
        appliesTo: 'tenant',
    },
    {
        code: 'ai-summary-basic',
        tierMin: 'solo',
        description: 'Resumo conversacional básico.',
        auditSeverity: 'info',
        category: 'ai',
        appliesTo: 'tenant',
    },
    {
        code: 'ai-classification-basic',
        tierMin: 'solo',
        description: 'Classificação básica de mensagens (sentimento, intenção).',
        auditSeverity: 'info',
        category: 'ai',
        appliesTo: 'tenant',
    },
    {
        code: 'ai-protection-active',
        tierMin: 'solo',
        description: 'Agente de proteção (escalação Nível 4, palavras-chave críticas).',
        auditSeverity: 'high',
        category: 'ai',
        appliesTo: 'tenant',
    },
    // Sprint Backend Protection v1 (PR-B Agent B) — Item 225 canonical Auditoria
    // Casos_Uso_2026-05-19 Frente 3 P0. Solo+ (proteção PII é higiênico básico LGPD).
    {
        code: 'ai-protection-outbound-validate',
        tierMin: 'solo',
        description: 'Validação pré-envio de mensagens outbound via protection-agent (PII, palavrões, Nível 4). Hook síncrono em MessagesService.sendOutbound antes de persistir.',
        auditSeverity: 'high',
        category: 'ai',
        appliesTo: 'tenant',
    },
    // Fatia 11.1 — inbound-trigger-agent. Solo+ universal. Proteção do cliente
    // em modo H_c (cliente pede humano / Nível 4 / ação irreversível / loop / tool-failure).
    {
        code: 'ai-inbound-trigger-detection',
        tierMin: 'solo',
        description: 'inbound-trigger-agent (Fatia 11.1) detecta gatilhos de retomada/escalação em mensagens inbound durante modo H_c (cliente pede humano, Nível 4, ação irreversível mencionada, loop, falha persistente de tool).',
        auditSeverity: 'high',
        category: 'ai',
        appliesTo: 'tenant',
    },
    // ─── Domínio ai-advanced (13) ──────────────────────────────────────────
    // Fatia 8 — fix retroativo: capabilities declaradas em role-mapping mas
    // não-materializadas no catálogo central durante PR #19 (regressão
    // capturada e corrigida na Fatia E).
    {
        code: 'ai-classification-with-history',
        tierMin: 'team',
        description: 'Trajetória longitudinal de classification + behavioral (quality_signals_history). Atendente Team+ consulta histórico para entender evolução.',
        auditSeverity: 'info',
        category: 'ai',
        appliesTo: 'tenant',
    },
    {
        code: 'ai-behavioral-analysis',
        tierMin: 'professional',
        description: 'behavioral-agent (ADR-036 #6 / ADR-032) detecta padrões cliente↔atendente. Supervisor+ consome para coaching e intervenção preventiva.',
        auditSeverity: 'info',
        category: 'ai',
        appliesTo: 'tenant',
    },
    {
        code: 'ai-risk-score-cumulative',
        tierMin: 'professional',
        description: 'Person.riskScore cumulativo via RiskScoreCalculator (Fatia 8 — ADR-052 placeholder pós-v1). Supervisor+ enxerga risco longitudinal.',
        auditSeverity: 'info',
        category: 'ai',
        appliesTo: 'tenant',
    },
    {
        code: 'ai-context-adversarial-filter',
        tierMin: 'professional',
        description: 'Filtra contexto IA por adversarialMode + side + visibility[] antes de invocar agente. Obrigatória em Regulated.',
        auditSeverity: 'high',
        category: 'ai',
        appliesTo: 'tenant',
    },
    // B-1 (17/Set/2026) — ai-cost-monitoring partiu em consumo do tenant
    // (ai-usage-read) e custo da plataforma (platform-ai-cost-read).
    {
        code: 'ai-usage-read',
        tierMin: 'professional',
        description: 'Consumo de IA do próprio tenant, agregado por agente/modelo/dia (tokens e invocações). NÃO carrega valor: o custo que a plataforma paga ao fornecedor é `platform-ai-cost-read`, e o valor pelo contrato do tenant chega na Fatia B. Sucessora de `ai-cost-monitoring` (auditoria de escopo 17/Set/2026, achado B-1).',
        auditSeverity: 'info',
        category: 'ai',
        appliesTo: 'tenant',
    },
    {
        code: 'platform-ai-cost-read',
        tierMin: 'professional',
        description: 'Custo que a plataforma paga ao fornecedor de IA, por tenant. Uso restrito da NetComet Soluções — mapeada SÓ para suporte_lume/engenharia_lume/direcao_lume, nunca para papel de tenant (auditoria de escopo 17/Set/2026, achado B-1). Consumidor: console apps/admin-lume (F3).',
        auditSeverity: 'info',
        category: 'ai',
        appliesTo: 'tenant',
    },
    {
        code: 'ai-billing-read',
        tierMin: 'solo',
        description: 'Leitura da carteira de IA do tenant: saldo, ciclo de carga, consumo %, extrato paginado e contrato de preço vigente. IA como serviço S2.',
        auditSeverity: 'info',
        category: 'ai',
        appliesTo: 'tenant',
    },
    {
        code: 'ai-billing-manage',
        tierMin: 'solo',
        description: 'Exportação do extrato da carteira de IA em CSV (livro-razão completo da janela). IA como serviço S2.',
        auditSeverity: 'info',
        category: 'ai',
        appliesTo: 'tenant',
    },
    // F1 «Nascimento do tenant» (19/Set/2026) — a porta do console da
    // plataforma. Mesmo escopo do B-1: só papéis *_lume, e o
    // PlatformScopeGuard como segunda camada.
    {
        code: 'platform-tenants-read',
        tierMin: 'professional',
        description: 'Ler a lista e a ficha de tenants da plataforma (nome, pacote, vertical, estado do ciclo de vida, saúde do provisionamento). Uso restrito da NetComet Soluções — mapeada SÓ para suporte_lume/engenharia_lume/direcao_lume, nunca para papel de tenant. Consumidor: console apps/admin-lume (F1). Defesa em profundidade: PlatformScopeGuard recusa /v1/platform/* vindo de outro tenant mesmo com a capability.',
        auditSeverity: 'info',
        category: 'admin',
        appliesTo: 'tenant',
    },
    {
        code: 'platform-tenants-manage',
        tierMin: 'professional',
        description: 'Provisionar tenant novo (TenantBlueprint → ProvisionReport) e operar o ciclo de vida dele a partir do console da plataforma. Uso restrito da NetComet Soluções — mapeada SÓ para suporte_lume/engenharia_lume/direcao_lume, nunca para papel de tenant. É a capability mais poderosa do produto: cria inquilino, primeiro admin e opt-in de capabilities. Consumidor: console apps/admin-lume (F1).',
        auditSeverity: 'high',
        category: 'admin',
        appliesTo: 'tenant',
    },
    // Política de preço na plataforma (21/Set/2026) — o preço de venda da
    // Lume é gesto da Lume: só papéis *_lume + PlatformScopeGuard.
    {
        code: 'platform-ai-pricing-read',
        tierMin: 'professional',
        description: 'Ver a tabela de preço de venda da plataforma (linha vigente, linha agendada e histórico fechado), o custo interno por modelo, o contrato de exceção de cada tenant e o painel de auditoria de cobrança. Uso restrito da NetComet Soluções — mapeada SÓ para suporte_lume/engenharia_lume/direcao_lume, nunca para papel de tenant. Consumidor: console apps/admin-lume.',
        auditSeverity: 'info',
        category: 'ai',
        appliesTo: 'tenant',
    },
    {
        code: 'platform-ai-pricing-manage',
        tierMin: 'professional',
        description: 'Reajustar preço de VENDA. Dois gestos com peso diferente: a exceção negociada de um tenant (uma pessoa) e a tabela global (proposta + segunda pessoa, via dual-approval). O reajuste global alcança todo tenant que não negociou, no mesmo gesto — por isso a segunda assinatura. Uso restrito da NetComet Soluções, nunca papel de tenant.',
        auditSeverity: 'high',
        category: 'ai',
        appliesTo: 'tenant',
    },
    // S4 «chave própria (BYOK)» (19/Set/2026) — a chave de IA do tenant.
    {
        code: 'ai-byok-manage',
        tierMin: 'professional',
        description: 'Cadastrar e rotacionar a chave de IA do PRÓPRIO tenant (BYOK). Gesto de dinheiro e de segredo: a chave vai para o cofre (ADR-156), o valor nunca volta por HTTP, e a troca é auditada. Separada de `ai-billing-manage` porque trazer a própria chave muda quem processa os dados no provedor — decisão de admin, não de operação.',
        auditSeverity: 'high',
        category: 'ai',
        appliesTo: 'tenant',
    },
    // Base de conhecimento do tenant (08/Out/2026) — só admin_tenant.
    {
        code: 'knowledge-base-author',
        tierMin: 'solo',
        description: 'Ler, criar, editar e remover a base de conhecimento do tenant (fatos que a IA afirma e condutas de como ela age — knowledge_entries), pelos endpoints admin /v1/knowledge-entries. Muda o que a IA diz ao cliente, por isso só admin_tenant e audit high. O conductor lê pela projeção do ConfigCacheService, não por esta capability.',
        auditSeverity: 'high',
        category: 'ai',
        appliesTo: 'tenant',
    },
    {
        code: 'ai-conductor-h-b',
        tierMin: 'team',
        description: 'Modo H_b — IA conduz com aprovação humana antes do envio.',
        auditSeverity: 'info',
        category: 'ai',
        appliesTo: 'tenant',
    },
    {
        code: 'ai-conductor-h-c',
        tierMin: 'professional',
        description: 'Modo H_c — IA conduz autonomamente com gating de proteção.',
        auditSeverity: 'high',
        category: 'ai',
        appliesTo: 'tenant',
    },
    // S5 (Condução Governada) — delegação por etapa (ex-"modo H_b", ADR-154).
    // Reconstituída no YAML em 12/Jul/2026 — vide nota de proveniência lá.
    {
        code: 'ai-step-delegation',
        tierMin: 'professional',
        description: 'Delegação por etapa (S5 — vereditos Q-D1..Q-D10 do adendo 2026-07-10): o operador delega um conjunto de objetivos do playbook à IA (janela de objetivo + timeout de segurança). A completude é DETERMINÍSTICA (código dispõe — successSignal de tool OU campos declarados presentes no rascunho da StructuredCollection + validação de formato CPF/CNPJ); ao fechar o conjunto (ou por saída de emergência: timeout/guard/takeover/cliente-desviou), a conversa volta ao DELEGANTE com nota interna e push. INVARIANTE Q-D2: coleta delegada NUNCA efetiva — nenhum cadastro/contrato/OS nasce pela IA. Roda sobre a máquina de delegação (H_c) existente e herda os gates de proteção (adversarial-strict bloqueia). Hook por-cliente BondParticipant.stepDelegationMode (default herda). Professional+ na v1 (roda sobre H_c; ADR-154 §5 previa Team+ — reconciliação como follow-up).',
        auditSeverity: 'high',
        category: 'ai',
        appliesTo: 'tenant',
    },
    // Items 279+280+281 — escalation por incerteza/desconhecimento (confidence < 0.5).
    // IA sugere transferência ao humano + aguarda consent cliente antes de
    // force mode H_c→H_a. Professional+ (pareada com ai-conductor-h-c).
    {
        code: 'ai-conductor-escalation',
        tierMin: 'professional',
        description: 'Conductor v3 escalation por incerteza/desconhecimento (Items 279+280+281). Quando confidence < 0.5, IA sugere transferência ao humano e aguarda consent do cliente antes de force mode H_c→H_a. Janela consent configurável via Tenant.hCEscalationConsentTimeoutSec (default 45s).',
        auditSeverity: 'high',
        category: 'ai',
        appliesTo: 'tenant',
    },
    // Items 267+268 (Fatia 11.2.1 continuação) — typing indicator canal-aware modo H_c.
    // Forward (267): "IA digitando" ao cliente ANTES da resposta (Telegram nativo +
    // Webchat WS + stubs no-op Meta). Reverso (268): pausa emit quando cliente
    // começa a digitar. Team+ via tier-filter. Gate Tenant.hCTypingIndicatorEnabled.
    {
        code: 'ai-typing-indicator',
        tierMin: 'team',
        description: 'Feedback "IA digitando" canal-aware ao cliente durante turno autônomo modo H_c (Items 267 forward + 268 reverso). Calibragem proporcional chars/120ms, cap [800ms, 10000ms]. Adapters: Telegram nativo, Webchat WS, stubs no-op canonical (WhatsApp Cloud API + Instagram DM + Email).',
        auditSeverity: 'info',
        category: 'ai',
        appliesTo: 'tenant',
    },
    {
        code: 'behavioral-analysis-full',
        tierMin: 'professional',
        description: 'Análise comportamental ampliada (perfil completo de Person).',
        auditSeverity: 'info',
        category: 'ai',
        appliesTo: 'tenant',
    },
    // Fatia 11.2 — auto-close H_c após inatividade configurada (Pro+).
    {
        code: 'ai-auto-close-h-c',
        tierMin: 'professional',
        description: 'Fechamento autônomo de conversa pelo conductor-agent em modo H_c quando playbook.autoCloseable=true (ADR-054 §B + Fatia 11.2). Validações: outcomeType ∈ autoCloseableOutcomes, sem checklist crítico pendente, sem BondParticipant adicional não-comum.',
        auditSeverity: 'high',
        category: 'ai',
        appliesTo: 'tenant',
    },
    // Fatia 11.2 — transition-agent (Team+, pacote Team alinhado Caderno cap 19).
    {
        code: 'ai-transition',
        tierMin: 'team',
        description: 'transition-agent (Fatia 11.2) detecta + propõe transições de playbook entre turnos do conductor (ADR-031 matriz declarativa). Executa direto em automatic_silent (H_c puro), aguarda confirmação em requires_confirmation (H_b/Regulated), escala em blocked.',
        auditSeverity: 'info',
        category: 'ai',
        appliesTo: 'tenant',
    },
    // Fase 2 multi-modelo (Sessão Code B2) — ADR-123. Seleção de modelo por
    // agente nominal no nível do tenant (Professional+ / admin_tenant). Grava
    // override per-tenant em ai_agents lido por resolveEffectiveModel (Fase 1).
    {
        code: 'custom-model-selection',
        tierMin: 'professional',
        description: 'Seleção customizada de modelo de IA por agente nominal no nível do tenant (ADR-123). Admin do tenant aponta o modelo efetivo de cada agente overridable (ex.: summary-agent → ollama/llama3.1) gravando override per-tenant em ai_agents que resolveEffectiveModel lê, e configura a cadeia-reserva de failover (opt-in por tenant, spec 14/Jun/2026). protection-agent é destatuado (modelOverridable=true), mas Anthropic é fortemente recomendado e sua cadeia-reserva nasce vazia (failover só por opt-in explícito do tenant). Não cobre perfil de privacidade / orçamento do §7.5 (sem backend na Fase 2).',
        auditSeverity: 'high',
        category: 'ai',
        appliesTo: 'tenant',
    },
    // ADR-149 — Verificação Proativa Pós-Resolução (motor SOA v1 da ADR-104).
    // Team+ via tier-filter. Dupla porta: a cap habilita o motor para o tenant;
    // o opt-in real é Playbook.verification.enabled (default off — P12).
    {
        code: 'proactive-verification',
        tierMin: 'team',
        description: 'Motor de Verificação Proativa Pós-Resolução (ADR-149): após o encerramento, condições determinísticas do catálogo (@lume/shared) agendam SOA e o worker dispara conversa proativa de verificação (template aprovado; modo H_a/H_b/H_c). Todo agendamento, dispatch, cancelamento e skip é auditado (P11/P12).',
        auditSeverity: 'high',
        category: 'ai',
        appliesTo: 'tenant',
    },
    // ADR-150 — Lembretes/Follow-ups de Agendamento (fontes appointment_* da
    // ADR-104). Solo+ (ADR-115 D115.3 dá D-1 a Solo). Dupla porta: a cap
    // habilita o motor; opt-in real é Tenant.appointmentReminderPolicy.enabled.
    {
        code: 'appointment-reminders',
        tierMin: 'solo',
        description: 'Motor de Lembretes e Follow-ups de Agendamento (ADR-150): Appointments criados/reagendados agendam SOAs nas antecedências da policy do tenant (defaults por pacote — ADR-115 D115.3) e o worker dispara a mensagem (na conversa ativa da identidade, ou em conversa proativa nova; modo H_a/H_b/H_c, default H_b). Follow-up pós-completed opcional. Todo agendamento, dispatch, cancelamento e skip é auditado (P11/P12).',
        auditSeverity: 'high',
        category: 'ai',
        appliesTo: 'tenant',
    },
    // AC3 — Motor de Confirmação Outbound de Agendamento D-1. A IA inicia
    // proativamente a conversa de confirmação (SOA appointment_confirmation_d1,
    // ADR-149/ADR-104), registra 'confirmed' em H_c, roteia "remarcar" ao AC1.
    // Solo+. Opt-in real = Tenant.appointmentConfirmationPolicy.enabled (off).
    {
        code: 'appointment-confirmation',
        tierMin: 'solo',
        description: 'Motor de Confirmação Outbound de Agendamento D-1 (AC3): a IA inicia proativamente a conversa de confirmação (SOA appointment_confirmation_d1, ADR-149/ADR-104), registra o desfecho `confirmed` autonomamente em modo H_c, roteia "remarcar" ao path de agendamento de campo (AC1, qualify_and_route), e escalona não-resposta em Pendency para o operador. Opt-in real = Tenant.appointmentConfirmationPolicy.enabled (default off P5). Todo disparo, confirmação, recusa e escalação é auditado (P11/P12).',
        auditSeverity: 'high',
        category: 'ai',
        appliesTo: 'tenant',
    },
    // Item 361 F1 — "Sugerir da conversa" (collection-agent on-demand com
    // provenance; materializa a D3 da ADR-144 / P14). Team+ via tier-filter;
    // Solo segue 100% manual via structured-collection.
    {
        code: 'ai-collection-extraction',
        tierMin: 'team',
        description: 'Extração de dados cadastrais da conversa pelo collection-agent (Item 361 — materializa a D3 diferida da ADR-144 / P14). On-demand pelo atendente (botão "Sugerir da conversa" no ColetaPanel): o agente lê APENAS mensagens do cliente da conversa (titular-only v1, bubble visibility do caller aplicada) e devolve campos candidatos COM provenance (messageId + trecho citado, validados server-side contra o conteúdo real — campo sem provenance válida é descartado). Preenche o RASCUNHO como sugestão marcada; a IA nunca finaliza (finalize segue humano + Pendency, ADR-144 D2). Team+ — Solo segue 100% manual via structured-collection. Audit por invocação (P11); custo por uso.',
        auditSeverity: 'info',
        category: 'ai',
        appliesTo: 'user',
    },
    // ─── Domínio bond/structure (3) ────────────────────────────────────────
    {
        code: 'bond-basic',
        tierMin: 'solo',
        description: 'Bond básico (tipo único, sem hierarquia).',
        auditSeverity: 'info',
        category: 'bond',
        appliesTo: 'tenant',
    },
    {
        code: 'bond-create',
        tierMin: 'solo',
        description: 'Criar novo Bond.',
        auditSeverity: 'info',
        category: 'bond',
        appliesTo: 'user',
    },
    {
        code: 'acl-granular-bond-level',
        tierMin: 'professional',
        description: 'ACL granular por Bond (camadas 1-4 da ADR-039).',
        auditSeverity: 'info',
        category: 'bond',
        appliesTo: 'tenant',
    },
    // ─── Domínio identity / monitoring (3) ────────────────────────────────
    // Brief 2B B2 — Person consolidação (Tela 2 "Pessoas"). Solo+.
    {
        code: 'person-read',
        tierMin: 'solo',
        description: 'Ler a visão consolidada de uma Pessoa (identidades, bonds, tutela, conversas).',
        auditSeverity: 'info',
        category: 'identity',
        appliesTo: 'user',
    },
    {
        code: 'silent-monitoring',
        tierMin: 'team',
        description: 'Acompanhamento silencioso de conversa por supervisor.',
        auditSeverity: 'high',
        category: 'coordination',
        appliesTo: 'user',
    },
    {
        code: 'identity-merge-confirm-by-operator',
        tierMin: 'team',
        description: 'Confirmar merge de Identity com confiança média.',
        auditSeverity: 'high',
        category: 'identity',
        appliesTo: 'user',
    },
    // ─── Domínio extended (14) ─────────────────────────────────────────────
    // Fatia 9 — Multi-canal estendido. Habilita preparação para canais
    // não-WhatsApp (Instagram DM, Telegram, email, webchat). WhatsApp continua
    // em `core-multi-channel-whatsapp` (Solo+). admin_tenant configura
    // TenantChannelConfig; atendente/supervisor/gestor operam via UI.
    {
        code: 'multi-channel-extended',
        tierMin: 'team',
        description: 'Multi-canal estendido (Instagram DM, Telegram, email, webchat). Habilita TenantChannelConfig para canais não-WhatsApp.',
        auditSeverity: 'info',
        category: 'conversation',
        appliesTo: 'tenant',
    },
    {
        code: 'personal-snippets',
        tierMin: 'solo',
        description: 'Snippets pessoais do atendente.',
        auditSeverity: 'debug',
        category: 'conversation',
        appliesTo: 'user',
    },
    {
        code: 'documents-basic',
        tierMin: 'team',
        description: 'Documents como entidade própria (sem versionamento avançado).',
        auditSeverity: 'info',
        category: 'document',
        appliesTo: 'tenant',
    },
    // Fatia D PR-A — catálogo canônico Documents conforme Caderno cap 37
    // + commit 239f7b3 (consolidação pós-auditoria pré-Fatia D).
    {
        code: 'documents-versioning',
        tierMin: 'team',
        description: 'Versionamento explícito de Documents (atendente cria nova versão; supersedes preserva histórico).',
        auditSeverity: 'info',
        category: 'document',
        appliesTo: 'tenant',
    },
    {
        code: 'documents-aggregated-view',
        tierMin: 'professional',
        description: 'Visualização agregada de Documents cross-conversation/bond do mesmo tenant.',
        auditSeverity: 'info',
        category: 'document',
        appliesTo: 'tenant',
    },
    {
        code: 'ai-document-summary',
        tierMin: 'professional',
        description: 'Resumo automático de Documents por agente nominal (summary-agent).',
        auditSeverity: 'info',
        category: 'document',
        appliesTo: 'tenant',
    },
    {
        code: 'documents-redaction',
        tierMin: 'professional',
        description: 'Redação de Documents (full-mask/partial-mask/metadata-only) com motivo LGPD/sensitive/legal.',
        auditSeverity: 'high',
        category: 'document',
        appliesTo: 'tenant',
    },
    // PR-B Fatia D Item 2 — Q2 Tech Lead 18/Mai/2026: capability separada
    // para reverter redação. Apply (Pro+) ≠ revert (Reg+) por sensibilidade
    // LGPD. Atribuída a dpo_tenant em DPO_TENANT_EXTRA.
    {
        code: 'documents-redaction-revert',
        tierMin: 'regulated',
        description: 'Reverter redação de Documents (DPO-only — preserva audit forense, libera acesso ao original).',
        auditSeverity: 'forensic',
        category: 'document',
        appliesTo: 'tenant',
    },
    {
        code: 'documents-acl-strict',
        tierMin: 'regulated',
        description: 'ACL strict-explicit em Documents (não herda de Bond/Conversation; grants explícitos obrigatórios).',
        auditSeverity: 'forensic',
        category: 'document',
        appliesTo: 'tenant',
    },
    {
        code: 'documents-digital-signing',
        tierMin: 'regulated',
        description: 'Assinatura digital de Documents (ICP-Brasil ou similar).',
        auditSeverity: 'forensic',
        category: 'document',
        appliesTo: 'tenant',
    },
    {
        code: 'checklist-system',
        tierMin: 'professional',
        description: 'Sistema de checklists revisional.',
        auditSeverity: 'info',
        category: 'checklist',
        appliesTo: 'tenant',
    },
    // Fatia E — Checklists com inteligência revisacional (ADR-045 + ADR-036 #9).
    {
        code: 'checklists-basic',
        tierMin: 'team',
        description: 'Checklists conversacionais — instanciação a partir de templates + fulfill manual + mark-not-applicable (justificativa obrigatória) + fail. Atendente Team+ recebe.',
        auditSeverity: 'info',
        category: 'checklist',
        appliesTo: 'tenant',
    },
    {
        code: 'checklists-with-agent',
        tierMin: 'professional',
        description: 'checklist-agent reativo (ADR-036 #9): propõe items cumpridos baseado em análise de mensagens + sinais classification (Fatia 8). Apenas propõe v1 — não auto-fulfilla.',
        auditSeverity: 'info',
        category: 'checklist',
        appliesTo: 'tenant',
    },
    {
        code: 'checklists-block-closure',
        tierMin: 'regulated',
        description: 'Bloqueio HARD de fechamento de conversa quando checklist crítico pendente (Regulated). Em Professional/Team o bloqueio é SOFT (warning + override com justificativa). ADR-045 + ADR-054 (Fatia F consome critical-pending).',
        auditSeverity: 'high',
        category: 'checklist',
        appliesTo: 'tenant',
    },
    // ─── Domínio lifecycle / sequences / groups (4) ───────────────────────────
    // Fatia F — ADR-043 + ADR-054 + ADR-055. Aplicação canônica P19.
    {
        code: 'conversation-lifecycle-strict',
        tierMin: 'solo',
        description: 'Ciclo de vida formal da Conversation com 7 estados canônicos (ADR-054). Matriz de transição hardcoded + bloqueios de fechamento (mensagem recente, checklist crítico, H_c pendente, adversarial strict). Core — não opcional, todos os papéis operacionais recebem.',
        auditSeverity: 'info',
        category: 'conversation',
        appliesTo: 'tenant',
    },
    {
        code: 'conversation-groups',
        tierMin: 'team',
        description: 'ConversationGroup (ADR-043): agrupamento ad-hoc analítico (manual ou semi-automático com confirmação humana). Supervisor/Gestor/Admin criam e gerenciam grupos para análise temática.',
        auditSeverity: 'info',
        category: 'coordination',
        appliesTo: 'tenant',
    },
    {
        code: 'conversation-sequences',
        tierMin: 'team',
        description: 'ConversationSequence (ADR-055): agrupamento automático de conversas em sucessão temporal próxima dentro do mesmo Bond+Person. Team+ visualização básica; Professional+ flags + alertas para gestor (highVolume / allAbandoned / escalatingSentiment / crossChannelInsistence).',
        auditSeverity: 'info',
        category: 'coordination',
        appliesTo: 'tenant',
    },
    {
        code: 'reopen-closed-conversations',
        tierMin: 'team',
        description: 'Reabrir conversa em estado terminal (resolved/closed-unresolved/archived/closed) via POST /v1/conversations/:id/reopen. Mapeada a supervisor+ (gestor/admin_tenant/admin_global herdam via extends). Atendente NÃO recebe — quem reabre é supervisor (mensagem canônica §2.8 do composer já comunica "ação de supervisor necessária").',
        auditSeverity: 'warning',
        category: 'conversation',
        appliesTo: 'tenant',
    },
    // ─── Domínio iniciar conversa proativa (4) ─────────────────────────────
    // Brief 2B T8 — atendente inicia proativamente (cobrança/visita/aviso).
    {
        code: 'initiate-proactive-conversation',
        tierMin: 'solo',
        description: 'Iniciar proativamente uma conversa com o cliente (o atendente abre o contato, não o cliente). Cobre os gatilhos de negócio pendency/commitment/appointment/conversation/cold. Carimba Conversation.origin=proactive + initiatedByUserId. Todos os papéis operacionais recebem (solo+).',
        auditSeverity: 'info',
        category: 'conversation',
        appliesTo: 'tenant',
    },
    {
        code: 'initiate-utility',
        tierMin: 'solo',
        description: 'Iniciar conversa proativa na categoria de sessão Meta "utility" (avisos/atualizações transacionais — ex.: confirmação de visita, lembrete de fatura). Carimba Conversation.metaSessionType=utility.',
        auditSeverity: 'info',
        category: 'conversation',
        appliesTo: 'tenant',
    },
    {
        code: 'initiate-service',
        tierMin: 'solo',
        description: 'Iniciar conversa proativa na categoria de sessão Meta "service" (atendimento/suporte iniciado pelo atendente). Carimba Conversation.metaSessionType=service.',
        auditSeverity: 'info',
        category: 'conversation',
        appliesTo: 'tenant',
    },
    {
        code: 'initiate-customer-care',
        tierMin: 'solo',
        description: 'Iniciar conversa proativa na categoria de sessão Meta "customer_care" (janela de atendimento ao cliente). Carimba Conversation.metaSessionType=customer_care.',
        auditSeverity: 'info',
        category: 'conversation',
        appliesTo: 'tenant',
    },
    // ─── Domínio inbox saved views (2) ─────────────────────────────────────
    // Brief 2B B3 — vistas salvas de filtros do inbox + compartilhamento.
    {
        code: 'inbox-saved-views',
        tierMin: 'solo',
        description: 'Salvar/listar/editar/remover as próprias vistas de filtros do inbox (SavedInboxView, Brief 2B B3). User-scoped — cada usuário gerencia apenas as suas. Solo+ universal.',
        auditSeverity: 'info',
        category: 'coordination',
        appliesTo: 'user',
    },
    {
        code: 'inbox-shared-views',
        tierMin: 'team',
        description: 'Compartilhar vistas salvas do inbox com outros usuários do tenant (isShared + sharedWith[]). Team+ — exige coordenação de equipe. Sem esta capability, a vista é forçada a privada.',
        auditSeverity: 'info',
        category: 'coordination',
        appliesTo: 'user',
    },
    // ─── Domínio agent dashboard (1) ───────────────────────────────────────
    // Brief 2B B5 — Painel Pessoal do atendente (Tela 5). Read-time user-scoped.
    {
        code: 'agent-dashboard-read',
        tierMin: 'solo',
        description: 'Ler o Painel Pessoal do atendente (Brief 2B B5, Tela 5) — composição read-time, user-scoped, das fontes do próprio operador (conversas ativas, pendências vencidas, appointments de hoje, sessões Meta, conflict alerts, SLA do turno) + layout de widgets via UserPreference. Caller-only: cada usuário vê apenas o seu painel (assignedToUserId/ownerUserId = caller). Solo+ universal. Sem snapshot/cron — composição a cada GET.',
        auditSeverity: 'info',
        category: 'coordination',
        appliesTo: 'user',
    },
    // ─── Domínio structured collection (1) ─────────────────────────────────
    // Brief 2B B6 — Coleta Estruturada de Dados (Tela 4, ADR-144). User-scoped.
    {
        code: 'structured-collection',
        tierMin: 'solo',
        description: `Coleta Estruturada de Dados (Brief 2B B6, Tela 4, ADR-144) — modal em que o atendente preenche manualmente um rascunho (StructuredCollection) de dados sobre a conversa, com auto-save / salvar parcial (If-Match), e ao finalizar grava os campos confirmados na Pessoa (PersonsService.update mínimo: name→displayName, cpf→primaryIdentifier, resto→metadata.collected), gera uma Pendency de revisão (source 'structured_collection') e referencia os documentIds[] já anexados à conversa. Entrada manual; extração-IA diferida. User-scoped (caller cria/edita o seu rascunho) + multi-tenant. Solo+ universal.`,
        auditSeverity: 'info',
        category: 'coordination',
        appliesTo: 'user',
    },
    // ─── Domínio appointment (1) ───────────────────────────────────────────
    // Sprint Backend Operacional Brief 2A r7b — Agent Y (ADR-115).
    {
        code: 'appointments',
        tierMin: 'solo',
        description: 'Appointment (ADR-115) — Agenda Operacional. Lume rastreia data/hora/partes/status/vínculo com Conversation; ERP (SuperGer) mantém OS/Atividade/equipe/materiais. Lifecycle scheduled/confirmed/imminent/completed/cancelled/no_show/rescheduled. Reschedule via ChainableEntity. If-Match optimistic concurrency (ADR-071). Atendente Solo+ recebe; cards "Appointments relacionados" renderizam no painel direito (Brief 2A r7b §31).',
        auditSeverity: 'info',
        category: 'coordination',
        appliesTo: 'tenant',
    },
    // ─── Domínio scheduling-native (1) ─────────────────────────────────────
    // Frente B Bloco I — Agenda Nativa (ADR-152, 29/Jun/2026).
    {
        code: 'scheduling-native',
        tierMin: 'solo',
        description: 'Agenda nativa (ADR-152 / Frente B) — a Lume é fonte da verdade da agenda do tenant (recurso agendável, janelas de trabalho, disponibilidade/livre-ocupado, recorrência, capacidade/grupo). Para tenants sem ERP. Distinta do appointment singular (cap `appointments`): esta liga o cálculo de disponibilidade + a trava anti-duplo-booking + o catálogo de recurso. As fontes externas (scheduling-external-*) ficam reservadas para v1.5+ (sync Google/Outlook/iCloud/SuperGer).',
        auditSeverity: 'info',
        category: 'coordination',
        appliesTo: 'tenant',
    },
    // ─── Domínio scheduling-waitlist (1) ───────────────────────────────────
    // Frente B Bloco IV — Grupo, capacidade & waitlist (30/Jun/2026).
    {
        code: 'scheduling-waitlist',
        tierMin: 'solo',
        description: 'Fila de espera (waitlist) da agenda nativa (Frente B Bloco IV) — quando um slot de grupo lota ou o horário do profissional está ocupado, o cliente entra numa fila por PREFERÊNCIA (serviço + recurso específico|qualquer-elegível + janela(s)); um cancelamento abre vaga e a promoção race-safe oferta/agenda honrando o modo (sequential/broadcast/manual), a priorização (FIFO + preferencial + urgência clínica) e a autonomia por-cliente. Depende de `scheduling-native` (a fila assenta sobre a disponibilidade capacity-aware e a guarda anti-duplo-booking). Gated OFF; merge não muda produção (soberania granular P19).',
        auditSeverity: 'info',
        category: 'coordination',
        appliesTo: 'tenant',
        requiresCapability: ['scheduling-native'],
    },
    // ─── Domínio operator-oncall (2) ───────────────────────────────────────
    // Frente N N3a-2 — escala de plantão do operador (06/Jul/2026); ativa o
    // regime 3 do gate de quiet-time N3a-1. Opt-in por-tenant (fora de pacote).
    {
        code: 'operator-oncall-schedule-read',
        tierMin: 'solo',
        description: 'Ler a escala de plantão do operador (OperatorOnCallShift — operador × vigência) e auto-marcar-se de plantão via POST /v1/operator-on-call-shifts/self (o veto final da auto-marcação é a política do tenant operatorNotificationPolicy.operatorCanSelfMarkOnCall; esta cap só destrava o endpoint). Frente N N3a-2 — base do regime 3 (sobreaviso) do gate de quiet-time. Consumida pela leitura "estou de plantão até …" no Perfil/T4 (N3b).',
        auditSeverity: 'info',
        category: 'coordination',
        appliesTo: 'tenant',
    },
    {
        code: 'operator-oncall-schedule-manage',
        tierMin: 'solo',
        description: 'Gerir a escala de plantão do operador — escalar QUALQUER operador (create), editar vigência/nota (patch If-Match) e remover (delete If-Match) shifts de OperatorOnCallShift. Prerrogativa de gestão (supervisor/coordenador): escalar um colega de plantão fora do expediente é ato de coordenação auditado (F.9). Frente N N3a-2 — ATIVA o regime 3 (sobreaviso: tier urgent fura fora do expediente) do gate de quiet-time N3a-1 em produção.',
        auditSeverity: 'info',
        category: 'coordination',
        appliesTo: 'tenant',
    },
    // ─── Domínio queue-limbo (1) ───────────────────────────────────────────
    // S4 Onda 4 (Condução Governada) — ack determinístico + modo recepcionista
    // na fila pós-escalação (11/Jul/2026). Opt-in por-tenant (fora de pacote);
    // gate duplo com Tenant.escalationLimboPolicy.
    {
        code: 'ai-queue-receptionist',
        tierMin: 'solo',
        description: 'Limbo da fila pós-escalação (S4 Onda 4 — vereditos Q-L1a/b do adendo 2026-07-10): (4a) ack determinístico honesto em TODOS os caminhos de escalação (incl. os antes mudos: level-4, adversarial-strict, escalate legado), com copy ciente de expediente (businessHours) + presença real (só copy — roteamento é o Item 386); (4b) modo recepcionista — a IA SEGURA a fila em H_c até o claim (escalationState awaiting_claim), com postura pela classe do MOTIVO persistido (1 conduz útil / 2 presença institucional determinística / 3 ack único e muda) e rate-limit em CÓDIGO por tenant (máx N msgs + intervalo mínimo + delay — o modelo nunca decide quantas vezes insistir). A mesma máquina serve a devolução de delegação interrompida por guard (Q-D6 — copy nomeia o delegante). Knobs em Tenant.escalationLimboPolicy (null = tudo OFF).',
        auditSeverity: 'high',
        category: 'ai',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    // ─── Domínio conductor-quick-replies (1) ───────────────────────────────
    // S5b (Condução Governada, veredito Q-D4, 12/Jul/2026) — quick replies
    // conversacionais v1 Telegram-first. Opt-in por-tenant (fora de pacote);
    // gate duplo com LUME_CONDUCTOR_QUICK_REPLIES_ENABLED.
    {
        code: 'conductor-quick-replies',
        tierMin: 'solo',
        description: 'Quick replies conversacionais v1 (S5b — veredito Q-D4): o conductor pode ofertar `quickReplies: [{label, payload}]` no output (prompt v16), renderizadas primeiro como `reply_markup.inline_keyboard` nativo do Telegram (um botão por linha). O clique volta como PAYLOAD ESTRUTURADO — sinal determinístico em `message.metadata.quickReplyPayload`, disponível para o step-gate/S5 consumirem sem inferência do modelo (amarra registrada; consumo é follow-up). WhatsApp interativo + widget webchat ficam para S7/follow-up.',
        auditSeverity: 'warning',
        category: 'ai',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    // ─── Domínio checklist-step-projection (1) ─────────────────────────────
    // S5c (Condução Governada, veredito Q-D3, 12/Jul/2026) — auto-instanciação
    // do checklist do playbook + auto-tick determinístico por-step. Opt-in
    // por-tenant (fora de pacote); checklist NUNCA influencia o step-gate.
    {
        code: 'checklist-step-projection',
        tierMin: 'professional',
        description: 'Checklist como PROJEÇÃO dos `steps` governados do Playbook (S5c, doutrina no Caderno cap 38): (1) auto-instancia o checklist do playbook (`Playbook.checklistTemplateId`, fio antes morto) quando a conversa ganha o playbook (gancho pós-`RoutingService.persist`, idempotente); (2) auto-tick DETERMINÍSTICO dos items ligados a um `stepId` (`ChecklistItem.stepId` → `GovernedStep.id`) quando o step correspondente fica satisfeito pelo MESMO sinal autoritativo do step-gate (`conductor.tool-invoked` — nunca um agregado de conveniência). O checklist NUNCA volta a influenciar o step-gate (doutrina: steps são a fonte, checklist é a projeção; tick humano é atestado, só satisfaz etapa `guiado` — `duro` sempre exige o sinal determinístico).',
        auditSeverity: 'info',
        category: 'ai',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    // ─── Domínio scheduled-journeys (1) ────────────────────────────────────
    // S6b (Condução Governada, veredito Q-J4, 12/Jul/2026) — Jornada Agendada:
    // serviço/verificação declara playbook alvo + abertura por canal. Opt-in
    // por-tenant (fora de pacote); gate triplo com LUME_SCHEDULED_JOURNEYS_ENABLED.
    {
        code: 'scheduled-journeys',
        tierMin: 'professional',
        description: 'Jornada Agendada (S6b — Condução Governada, spec `docs/superpowers/specs/2026-07-12-S6b-jornada-agendada-design.md`): um serviço da agenda nativa (`ServiceOffering.journeyPolicy`) ou a verificação proativa de um playbook (`Playbook.verification.targetPlaybookId`) declara um playbook ALVO + abertura por canal (texto livre; template HSM aprovado quando WhatsApp). No vencimento (SOA fonte `appointment_journey`, ou generalização da fonte `playbook_verification`), abre/redireciona a conversa proativa para nascer CONDUZIDA pelo playbook alvo (steps/step-gates da Frente C aplicam integralmente) — zero LLM no disparo, zero máquina de condução nova.',
        auditSeverity: 'high',
        category: 'ai',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    // ─── Domínio proactive-outbound-task (1) — F3 Modo Outbound ─────────────
    // F3 «Vínculo, Contexto e Memória entre Conversas» — a plataforma inicia
    // conversa com meta (playbook) e conduz. Opt-in por-tenant (fora de pacote);
    // gate triplo com LUME_OUTBOUND_TASK_ENABLED + config que enfileira a SOA.
    {
        code: 'proactive-outbound-task',
        tierMin: 'professional',
        description: 'Modo Outbound (F3 — «Vínculo, Contexto e Memória entre Conversas», `docs/superpowers/specs/2026-07-20-f3-modo-outbound-design.md`): a plataforma INICIA uma conversa sozinha, com uma meta declarada (o playbook), e a conduz até o objetivo — reusando o dispatch proativo e o conductor (que retoma `origin=proactive`). Caso-farol: follow-up de satisfação pós-atendimento (SOA fonte `outbound_task`). Gate triplo com `LUME_OUTBOUND_TASK_ENABLED` + a config que enfileira. Content-neutral (o texto do follow-up vive no playbook do tenant; o motor é agnóstico de vertical/integrador).',
        auditSeverity: 'high',
        category: 'ai',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    // ─── Domínio proactive-outbound-campaign (1) — F4 Raiz de Tarefa/Campanha ─
    // F4 «Vínculo, Contexto e Memória entre Conversas» — 1 tarefa-mãe → N
    // conversas outbound irmãs (reusa a primitiva F3 outbound_task por-filho).
    // Opt-in por-tenant (fora de pacote); gate composto com
    // LUME_OUTBOUND_CAMPAIGN_ENABLED + (por-filho) o gate da F3.
    {
        code: 'proactive-outbound-campaign',
        tierMin: 'professional',
        description: 'Raiz de Tarefa/Campanha (F4 — «Vínculo, Contexto e Memória entre Conversas», docs/superpowers/specs/2026-07-21-f4-raiz-tarefa-campanha-design.md): uma tarefa-mãe dispara N conversas outbound irmãs (reusando a primitiva F3 `outbound_task` por-filho), com slots-alvo comuns, um agregador genérico e human-in-the-loop no fechamento. Gate composto com `LUME_OUTBOUND_CAMPAIGN_ENABLED` + (por-filho) o gate da F3. Content-neutral (o motor é agnóstico de vertical/integrador; o texto vive no playbook do tenant).',
        auditSeverity: 'high',
        category: 'ai',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    // ─── Domínio outbound-rfq (1) — F5 RFQ/cotação multi-fornecedor ──────────
    // F5 «Vínculo, Contexto e Memória» — consolida N cotações de uma Raiz F4
    // numa matriz p/ DECISÃO HUMANA (IA coleta+consolida, humano decide; sem
    // winner automático). Opt-in; gate composto com LUME_OUTBOUND_RFQ_ENABLED.
    {
        code: 'outbound-rfq',
        tierMin: 'professional',
        description: 'RFQ / cotação multi-fornecedor (F5 — «Vínculo, Contexto e Memória entre Conversas», docs/superpowers/specs/2026-07-21-f5-rfq-consolidacao-design.md): consolida as N cotações de uma Raiz de Tarefa (F4) numa matriz de comparação por slot × fornecedor para DECISÃO HUMANA (a IA coleta e consolida; o humano decide/fecha; a IA NUNCA compromete preço/condição sozinha — sem winner/ranking automático). Camada de consumo read-only sobre a raiz F4. Gate composto com `LUME_OUTBOUND_RFQ_ENABLED`. Content-neutral (fornecedor/cotação sem literal setorial; sem MCP-específico no código). Fase ESPECULATIVA (sem alvo MCP real de procurement) — validação só estrutural; os valores por-fornecedor dependem do filledSlots (M3 da F3, diferido).',
        auditSeverity: 'high',
        category: 'ai',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    // ─── Domínio retention-active-trigger-calibration (1) ──────────────────
    // A3 «Retenção Ativa» (netcomet_demo, 17/Jul/2026) — calibração gated do
    // inbound-trigger-agent: 'irreversible-action' na MENÇÃO de cancelamento cai
    // para o conductor (a Retenção conduz), efetivação barrada downstream. Opt-in
    // por-tenant LOCALITY-AWARE (só o grant LOCAL liga; entry global ignorado).
    {
        code: 'retention-active-trigger-calibration',
        tierMin: 'solo',
        description: 'Calibração gated do inbound-trigger-agent para a frente Retenção Ativa: quando concedida como registry entry LOCAL do tenant, o gatilho `irreversible-action` deixa de escalar na simples MENÇÃO de cancelamento e o turno cai para o conductor (a Retenção conduz a conversa dor→brecha→negociação). A EFETIVAÇÃO do cancelamento segue barrada pelos gates downstream (identidade + step-gate + tool-gate) — a IA nunca executa a baixa. Gate LOCALITY-AWARE por-tenant: só o grant LOCAL liga a calibração; o entry do catálogo global é ignorado (o fallback do lookup concede a todos). Os demais 4 pisos de plataforma seguem intocados. Nasce gated ao netcomet_demo; produção byte-idêntica.',
        auditSeverity: 'warning',
        category: 'ai',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    // ─── Domínio capability / admin (4) ────────────────────────────────────
    {
        code: 'capability-registry-read',
        tierMin: 'solo',
        description: 'Listar e ler entries do Capability Registry.',
        auditSeverity: 'debug',
        category: 'capability',
        appliesTo: 'user',
    },
    {
        code: 'capability-registry-manage',
        tierMin: 'professional',
        description: 'Criar / atualizar / desativar entries do Capability Registry.',
        auditSeverity: 'high',
        category: 'capability',
        appliesTo: 'user',
    },
    {
        code: 'tenant-config-read',
        tierMin: 'solo',
        description: 'Ler configuração do tenant (feature flags, perfis).',
        auditSeverity: 'debug',
        category: 'admin',
        appliesTo: 'user',
    },
    {
        code: 'tenant-config-manage',
        tierMin: 'team',
        description: 'Modificar configuração do tenant (toggle feature flags, etc).',
        auditSeverity: 'high',
        category: 'admin',
        appliesTo: 'user',
    },
    // ─── Domínio lgpd (2) ──────────────────────────────────────────────────
    {
        code: 'lgpd-requests-management',
        tierMin: 'team',
        description: 'Gestão de pedidos LGPD do titular (acesso, retificação, exclusão).',
        auditSeverity: 'forensic',
        category: 'lgpd',
        appliesTo: 'user',
    },
    {
        code: 'lgpd-anonymization-execute',
        tierMin: 'professional',
        description: 'Executar anonimização de Person.',
        auditSeverity: 'forensic',
        category: 'lgpd',
        appliesTo: 'user',
        requiresCapability: ['lgpd-requests-management'],
    },
    // ─── Domínio audit (3) ─────────────────────────────────────────────────
    {
        code: 'audit-events-read',
        tierMin: 'team',
        description: 'Ler audit_events do tenant.',
        auditSeverity: 'info',
        category: 'audit',
        appliesTo: 'user',
    },
    {
        code: 'audit-events-read-sensitive',
        tierMin: 'professional',
        description: 'Ler audit_events sensíveis (forensic level).',
        auditSeverity: 'high',
        category: 'audit',
        appliesTo: 'user',
    },
    // PR S0 — Brief 3 Supervisor backend bundle (AuditOperationChain pattern).
    // Phase 4 Task 9 — destrava endpoints /v1/audit-chain/*. Atendente NÃO recebe.
    {
        code: 'audit-chain-replay',
        tierMin: 'professional',
        description: 'Visualizar replay completo de uma chain de operationId (auditoria forense da cadeia de decisão cross-module — PR S0 Brief 3 Supervisor).',
        auditSeverity: 'high',
        category: 'audit',
        appliesTo: 'user',
    },
    // ─── Domínio regulated (4) ─────────────────────────────────────────────
    {
        code: 'legal-capacity-management',
        tierMin: 'regulated',
        description: 'Gestão de capacidade legal (interditados, menores, curatela).',
        auditSeverity: 'forensic',
        category: 'identity',
        appliesTo: 'tenant',
    },
    {
        code: 'confidentiality-bubbles-full',
        tierMin: 'regulated',
        description: 'Bolhas de confidencialidade completas (mediação adversarial).',
        auditSeverity: 'forensic',
        category: 'adversarial',
        appliesTo: 'tenant',
    },
    {
        code: 'conflict-of-interest-detection',
        tierMin: 'professional',
        description: 'Detecção automatizada de conflitos de interesse (ADR-050) — categoria A v1 (cross-pessoa via BondRelatedPerson).',
        auditSeverity: 'high',
        category: 'adversarial',
        appliesTo: 'tenant',
    },
    // Fatia 11.2 — bloqueio adversarial Regulated (ADR-050 §"Comportamento por
    // pacote comercial" — IA continua em modo bloqueante mesmo após conflict).
    {
        code: 'conflict-of-interest-blocking',
        tierMin: 'regulated',
        description: 'ConflictAlert aberto envolvendo Bond da conversa em modo H_c pausa H_c automaticamente em pacote Regulated (ADR-050 + Fatia 11.2). Audit `ai.conducting.conflict-blocked` canonical.',
        auditSeverity: 'forensic',
        category: 'adversarial',
        appliesTo: 'tenant',
    },
    // ─── Domínio peer-coordination (4) ─────────────────────────────────────
    // Fatia G — ADR-049 + Caderno cap 39. Capabilities granulares (refina
    // ADR-049 original que propôs 2 amalgamadas — `team-coordination` +
    // `team-coordination-advanced`). Caderno + ficha são fonte canônica.
    {
        code: 'peer-coordination-handoff',
        tierMin: 'team',
        description: 'Handoff (ADR-049 + Caderno cap 39) — transferência formal de conversa entre atendentes (push: A escolhe B; pull: A coloca em fila aberta). NetComet usa push (handoffMode tenant-level).',
        auditSeverity: 'info',
        category: 'coordination',
        appliesTo: 'tenant',
    },
    {
        code: 'peer-coordination-presence',
        tierMin: 'team',
        description: 'AttendantPresence — status presencial em tempo real (online/away/busy/offline/on-call) via WebSocket. Visível na bandeja, listagens, handoff push.',
        auditSeverity: 'info',
        category: 'coordination',
        appliesTo: 'tenant',
    },
    {
        code: 'peer-coordination-internal-notes',
        tierMin: 'team',
        description: 'InternalNote — anotação interna sobre conversa (3 visibilidades: public-team / private-author / private-supervisors). NÃO chega ao cliente. Default public-team.',
        auditSeverity: 'info',
        category: 'coordination',
        appliesTo: 'tenant',
    },
    {
        code: 'peer-coordination-co-attendance',
        tierMin: 'professional',
        description: 'CoAttendance — co-atendimento simultâneo (3 roles: shadow-observer / collaborative-observer / supervisor-monitor). Sênior acompanha júnior, supervisor monitora, especialista entra.',
        auditSeverity: 'high',
        category: 'coordination',
        appliesTo: 'tenant',
    },
    // ─── Mensagem dirigida — mensageria interna entre operadores ─────────
    // - direct-message-participate: Team+ todos os operadores — ler/responder
    //   thread + badge de não-lido. Iniciar thread = direct-message-initiate.
    // - direct-message-initiate: Team+ supervisor — iniciar thread 1:1 ou
    //   broadcast ao time. Responder em thread existente não exige esta cap.
    // - direct-message-initiate-upward: Team+ atendente — iniciar thread 1:1
    //   ASCENDENTE restrito aos próprios supervisores (Mensageria Condensada PR B1).
    // - direct-message-initiate-lateral / -anyone: Team+ OPT-IN via
    //   additionalCapabilities (fora do role mapping) — iniciar 1:1 com pares do
    //   time / qualquer operador do tenant (mensageria lateral configurável).
    {
        code: 'direct-message-participate',
        tierMin: 'team',
        description: 'Mensageria interna entre operadores — ler e responder threads de mensagem dirigida em que o usuário participa, e ver o badge de não-lido. Concedida a todos os papéis operadores (Team+; mensageria entre operadores só faz sentido com 2+ pessoas).',
        auditSeverity: 'info',
        category: 'coordination',
        appliesTo: 'user',
    },
    {
        code: 'direct-message-initiate',
        tierMin: 'team',
        description: 'Mensageria interna entre operadores — INICIAR um thread dirigido a um atendente (1:1) ou fazer broadcast ao time (canal de grupo OU aviso individual fan-out). Concedida ao supervisor (Team+). Responder em thread existente não exige esta cap (basta participar — direct-message-participate).',
        auditSeverity: 'info',
        category: 'coordination',
        appliesTo: 'user',
    },
    {
        code: 'direct-message-initiate-upward',
        tierMin: 'team',
        description: 'Mensageria interna entre operadores — INICIAR thread dirigido ASCENDENTE (1:1), restrito aos próprios supervisores do ator (supervisor direto via reportsTo + líderes dos times de que é membro). Concedida ao atendente (Team+), permitindo que ele fale "para cima" sem alcançar pares nem subordinados. NÃO afrouxa a iniciação descendente do supervisor (direct-message-initiate). Responder em thread existente não exige esta cap (basta direct-message-participate).',
        auditSeverity: 'info',
        category: 'coordination',
        appliesTo: 'user',
    },
    {
        code: 'direct-message-initiate-lateral',
        tierMin: 'team',
        description: 'Mensageria interna entre operadores — INICIAR thread dirigido LATERAL (1:1) com PARES: qualquer membro dos times de que o ator também é membro (exclui a si mesmo). OPT-IN por operador (NÃO concedida a nenhum papel por default — ligada via additionalCapabilities), destrava colaboração horizontal sem passar pelo supervisor. Responder segue só com direct-message-participate; broadcast NÃO é afetado (segue descendente).',
        auditSeverity: 'info',
        category: 'coordination',
        appliesTo: 'user',
    },
    {
        code: 'direct-message-initiate-anyone',
        tierMin: 'team',
        description: 'Mensageria interna entre operadores — INICIAR thread dirigido (1:1) com QUALQUER operador ativo do tenant. OPT-IN por operador (NÃO concedida por default — via additionalCapabilities), para operações flat/abertas. Superset de direct-message-initiate-lateral. Responder/broadcast inalterados.',
        auditSeverity: 'info',
        category: 'coordination',
        appliesTo: 'user',
    },
    // ─── Domínio mobile / app móvel (8) ────────────────────────────────────
    // Caminho A pré-Sprint Mobile Code — consolidação Item 56 (ADR-116 +
    // Sessão A com renomeação canônica para prefixo `mobile-app-*` quando
    // aplicável; Sessão A nomes legados — `mobile-push-notifications`,
    // `mobile-multi-device-simultaneous` — descartados em favor de ADR-116).
    // ADR-136 documenta a consolidação.
    //
    // `push-notification-retry-policy` NÃO entra como capability — é policy
    // class do Registry polimórfico (ADR-082), conforme nota em Sessão A §3.4
    // pós R14 reversa Item 56.
    {
        code: 'mobile-app-access',
        tierMin: 'solo',
        description: 'Operador pode usar o app móvel Lume Atendimento.',
        auditSeverity: 'info',
        category: 'mobile',
        appliesTo: 'tenant',
    },
    {
        code: 'mobile-app-multi-device',
        tierMin: 'solo',
        description: 'User pode manter N UserSessions ativas simultâneas (web + mobile + outro mobile). Sempre cross-type; restrição apenas intra-type (1 sessão mobile_ios ativa por user).',
        auditSeverity: 'info',
        category: 'mobile',
        appliesTo: 'tenant',
    },
    {
        code: 'mobile-app-admin-remote-logout',
        tierMin: 'team',
        description: 'Admin/Gestor revoga UserSession remotamente (device perdido/roubado/comprometido). Audit forense da ação (revokedSource=admin_remote_logout).',
        auditSeverity: 'high',
        category: 'mobile',
        appliesTo: 'user',
    },
    {
        code: 'mobile-app-push-notifications',
        tierMin: 'solo',
        description: 'Push notifications via FCM/APNs para mensagens, pendências, conflict alerts, appointments. Lifecycle queued → sending → sent → delivered (ADR-116).',
        auditSeverity: 'info',
        category: 'mobile',
        appliesTo: 'tenant',
    },
    {
        code: 'mobile-app-push-customize-types',
        tierMin: 'team',
        description: 'Tenant configura quais event types disparam push notifications + override sobre quiet hours por user.',
        auditSeverity: 'info',
        category: 'mobile',
        appliesTo: 'tenant',
    },
    {
        code: 'mobile-app-session-anomaly-detection',
        tierMin: 'professional',
        description: 'Detecção de anomalia em UserSession (login geo-distante, device novo desconhecido, IP suspeito). Marca session com suspicious flag + alerta admin/DPO.',
        auditSeverity: 'high',
        category: 'mobile',
        appliesTo: 'tenant',
    },
    {
        code: 'mobile-biometric-login',
        tierMin: 'solo',
        description: 'Login via Face ID / Touch ID / Fingerprint no app móvel (expo-local-authentication ou bare native APIs). Pode ser desabilitado por tenant Regulated com requisito de senha forte mandatório.',
        auditSeverity: 'info',
        category: 'mobile',
        appliesTo: 'tenant',
    },
    {
        code: 'mobile-offline-cache',
        tierMin: 'team',
        description: 'App móvel armazena conversas recentes localmente para acesso sem rede. Read offline; envios em fila local até reconectar. Conflict resolution last-write-wins v1.',
        auditSeverity: 'info',
        category: 'mobile',
        appliesTo: 'tenant',
    },
    // ─── Domínio auth / profile mobile-relacionado (5) ──────────────────────
    // Caminho A pré-Sprint Mobile Code — consolidação Item 58 (5 capabilities
    // declaradas em `fixtures-6.js` MOBILE_BASE_EXTRA/MOBILE_PRO_PLUS;
    // semanticamente auth/profile não-mobile-lifecycle; aplicáveis também
    // a Web quando UI consumir SSO/2FA/profile-photo).
    // ADR-136 + ADR-138 documentam a consolidação + auth flow canônico.
    {
        code: 'profile-photo-edit',
        tierMin: 'solo',
        description: 'Edição de foto de perfil do user no T6 Perfil Mobile (também aplicável a Web). Upload + crop + remoção.',
        auditSeverity: 'info',
        category: 'profile',
        appliesTo: 'user',
    },
    {
        code: 'sso-google',
        tierMin: 'solo',
        description: 'SSO via Google (OAuth 2.0 + OIDC) — Login Mobile/Web.',
        auditSeverity: 'info',
        category: 'authentication',
        appliesTo: 'tenant',
    },
    {
        code: 'sso-apple',
        tierMin: 'team',
        description: 'SSO via Sign in with Apple (obrigatório iOS quando outro SSO oferecido).',
        auditSeverity: 'info',
        category: 'authentication',
        appliesTo: 'tenant',
    },
    {
        code: 'sso-microsoft',
        tierMin: 'professional',
        description: 'SSO via Microsoft Azure AD / Entra ID — empresas corporativas com diretório próprio.',
        auditSeverity: 'info',
        category: 'authentication',
        appliesTo: 'tenant',
    },
    {
        code: 'two-factor-auth',
        tierMin: 'solo',
        description: 'Two-factor authentication (TOTP via authenticator app preferido; SMS fallback opcional). Habilitável por user; pode ser forçado por tenant Regulated.',
        auditSeverity: 'high',
        category: 'authentication',
        appliesTo: 'user',
        requiresCapability: ['core-authentication'],
    },
    // ─── Domínio users-manage Wave 2 W2.1 (6) ──────────────────────────────
    // ACL 5 camadas ADR-039 + Brief 5 A1 Gestão Usuários frontend Wave 3.
    {
        code: 'users-read',
        tierMin: 'team',
        description: 'Listar e ler usuários do tenant (list/detail/hierarchy). Gestor+ gerencia equipes; supervisor lê sua própria equipe.',
        auditSeverity: 'info',
        category: 'admin',
        appliesTo: 'user',
    },
    {
        code: 'users-create',
        tierMin: 'team',
        description: 'Criar novo usuário no tenant. Gera user com mfaPending=true (setup na primeira sessão). Requer e-mail único no tenant.',
        auditSeverity: 'info',
        category: 'admin',
        appliesTo: 'user',
    },
    {
        code: 'users-update',
        tierMin: 'team',
        description: 'Atualizar campos de usuário existente (nome, role, reportsTo, capabilities adicionais). Optimistic concurrency via If-Match ADR-071.',
        auditSeverity: 'info',
        category: 'admin',
        appliesTo: 'user',
    },
    {
        code: 'users-deactivate',
        tierMin: 'team',
        description: 'Desativar (arquivar) usuário do tenant. Soft-delete — histórico preservado para auditoria. Requer motivo (texto livre ≥5 chars).',
        auditSeverity: 'high',
        category: 'admin',
        appliesTo: 'user',
    },
    {
        code: 'users-invite',
        tierMin: 'team',
        description: 'Enviar convite por e-mail para novo usuário (InviteToken TTL 7 dias). SMTP placeholder v1 (P4 resistência over-engineering — materializar SendGrid/SES em fatia futura).',
        auditSeverity: 'info',
        category: 'admin',
        appliesTo: 'user',
    },
    {
        code: 'users-impersonate',
        tierMin: 'regulated',
        description: 'Impersonar usuário do tenant (admin_tenant only — exclusivo para suporte técnico forense e auditoria DPO). Cada uso gera audit forensic obrigatório.',
        auditSeverity: 'forensic',
        category: 'admin',
        appliesTo: 'user',
    },
    // ─── Domínio lgpd Wave 2 W2.2 extras (5) ───────────────────────────────
    // lgpd/ módulo Item I4-A — Brief 5 B1 Centro Direitos + B5 wizard.
    {
        code: 'lgpd-requests-read',
        tierMin: 'team',
        description: 'Ler solicitações LGPD, legal holds e registros de anonimização.',
        auditSeverity: 'forensic',
        category: 'lgpd',
        appliesTo: 'user',
    },
    {
        code: 'lgpd-requests-create',
        tierMin: 'team',
        description: 'Criar nova solicitação LGPD em nome do titular ou pelo operador.',
        auditSeverity: 'forensic',
        category: 'lgpd',
        appliesTo: 'user',
        requiresCapability: ['lgpd-requests-read'],
    },
    {
        code: 'lgpd-requests-approve',
        tierMin: 'team',
        description: 'Transitar status de solicitação LGPD, atribuir DPO e estender prazo.',
        auditSeverity: 'forensic',
        category: 'lgpd',
        appliesTo: 'user',
        requiresCapability: ['lgpd-requests-read'],
    },
    {
        code: 'lgpd-requests-execute',
        tierMin: 'professional',
        description: 'Executar anonimização irreversível — exclusivo DPO.',
        auditSeverity: 'forensic',
        category: 'lgpd',
        appliesTo: 'user',
        requiresCapability: ['lgpd-requests-approve'],
    },
    {
        code: 'lgpd-legal-holds-manage',
        tierMin: 'professional',
        description: 'Criar e levantar bloqueios legais (legal holds) sobre entidades.',
        auditSeverity: 'forensic',
        category: 'lgpd',
        appliesTo: 'user',
        requiresCapability: ['lgpd-requests-read'],
    },
    // Item 350 — contatos autorizados do Bond: DPO sempre gerencia (gating
    // restritivo por nicho via Tenant.authorizedContactsDpoOnly).
    {
        code: 'lgpd-authorized-contacts-read',
        tierMin: 'team',
        description: 'Ler contatos autorizados de um Bond (LGPD ADR-129) — papel DPO.',
        auditSeverity: 'forensic',
        category: 'lgpd',
        appliesTo: 'user',
    },
    {
        code: 'lgpd-authorized-contacts-manage',
        tierMin: 'team',
        description: 'Gerenciar (criar/editar/revogar) contatos autorizados de um Bond (LGPD ADR-129) — papel DPO.',
        auditSeverity: 'forensic',
        category: 'lgpd',
        appliesTo: 'user',
        requiresCapability: ['lgpd-authorized-contacts-read'],
    },
    // ─── Domínio tenant-lifecycle (3) ──────────────────────────────────────
    {
        code: 'tenant-lifecycle-read',
        tierMin: 'professional',
        description: 'Ler status lifecycle do Tenant + history de transições (T13 Tenant Lifecycle Dashboard — ADR-111).',
        auditSeverity: 'info',
        category: 'admin',
        appliesTo: 'tenant',
    },
    {
        code: 'tenant-lifecycle-transition',
        tierMin: 'professional',
        description: 'Disparar transições manuais do lifecycle de Tenant (ADR-111) — admin_tenant exclusivo.',
        auditSeverity: 'high',
        category: 'admin',
        appliesTo: 'tenant',
    },
    {
        code: 'tenant-lifecycle-churning-initiate',
        tierMin: 'professional',
        description: 'Iniciar e cancelar workflow de churning de Tenant com cascata LGPD ADR-110 (D111.2 + D111.3).',
        auditSeverity: 'forensic',
        category: 'admin',
        appliesTo: 'tenant',
    },
    // ─── Domínio supervision (1) ────────────────────────────────────────────
    // D6 Auditoria Periódica 19/Mai/2026 — Item 138 candidato resolvido.
    // Brief 3 T1 Painel da Equipe; capability dedicada vs silent-monitoring fallback.
    {
        code: 'supervisor-team-panel',
        tierMin: 'team',
        description: 'Acesso ao Painel de Equipe (Brief 3 T1) — dashboard supervisor com cards de atendentes + presence + SLA breach + sentiment trend.',
        auditSeverity: 'info',
        category: 'supervision',
        appliesTo: 'user',
    },
    // ─── Domínio customer-commitments (2) ──────────────────────────────────
    // Sprint Backend Operacional X — CustomerCommitment ADR-105.
    // Brief 2A r7b §26 — CustomerCommitmentBlock painel direito.
    {
        code: 'commitments',
        tierMin: 'solo',
        description: 'CustomerCommitment basic (ADR-105) — listar + marcar fulfilled/cancelled. Atendente vê e gerencia promessas detectadas pela IA.',
        auditSeverity: 'info',
        category: 'conversation',
        appliesTo: 'tenant',
    },
    {
        code: 'commitments-full',
        tierMin: 'professional',
        description: 'CustomerCommitment full (Pro+) — supervisor/gestor pode override cancellation + bulk operations + auditar histórico cross-conversation.',
        auditSeverity: 'info',
        category: 'conversation',
        appliesTo: 'user',
    },
    // ─── Domínio conversation-commitments (1) ───────────────────────────────
    // S2 Motor de Compromisso — promessa do operador/IA ao cliente extraída
    // pelo commitment-extraction-agent + persistida como Pendency. Opt-in
    // por-tenant, dual-gate com LUME_COMMITMENT_EXTRACTION_ENABLED (13/Jul/2026).
    {
        code: 'conversation-commitments',
        tierMin: 'solo',
        description: `Motor de Compromisso (Corrente de Compromissos S2) — extração conversacional da promessa que o OPERADOR ou a IA fez AO cliente. O \`commitment-extraction-agent\` lê cada mensagem outbound (attendant/ai), o CÓDIGO decide (determinístico) e persiste a promessa legítima como Pendency (source='conversation-promise', category='commitment') com dono (o operador responsável), prazo (heurístico quando implícito) e dedupe/re-promessa (tag repromised:N). Vigilância de cumprimento: um outbound que ENTREGA o prometido resolve a Pendency. Métrica de falsificação embutida (\`GET /v1/commitments/extraction-metrics\` — correctionRate derivado do audit). DUAL-GATE com a flag \`LUME_COMMITMENT_EXTRACTION_ENABLED\` (default OFF). Tenant-scoped; opt-in real via CapabilityEntry.`,
        auditSeverity: 'info',
        category: 'conversation',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    // ─── Domínio conversation-reengagement (1) ─────────────────────────────
    // Reaquecimento Julgado — o cliente calou no meio da conversa conduzida
    // pela IA; o reengagement-agent julga se vale voltar a falar e com que
    // ângulo. Relógio adaptado à mediana de resposta da pessoa. Opt-in
    // por-tenant, dual-gate com LUME_REENGAGEMENT_ENABLED (04/Ago/2026).
    {
        code: 'conversation-reengagement',
        tierMin: 'solo',
        description: 'Reaquecimento Julgado — quando o CLIENTE para de responder no meio de uma conversa conduzida pela IA, um agente nominal (`reengagement-agent`) julga se vale voltar a falar e com que ângulo (`resume` retoma o assunto; `repair` reconhece a fricção que calou o cliente; `close`/`never` não falam), e o conductor redige num 2º passo com contexto espesso. O relógio é adaptado à pessoa: o silêncio precisa destoar da mediana histórica de resposta dela, não de um timeout fixo. Sem retorno após os toques configurados, a conversa encerra com dignidade e registra desfecho — para de existir conversa não-acabada. Toques, janelas e apetite são configuráveis pelo tenant (camada 3). DUAL-GATE com a flag `LUME_REENGAGEMENT_ENABLED` (default OFF). Tenant-scoped; opt-in real via CapabilityEntry.',
        auditSeverity: 'info',
        category: 'conversation',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    // ─── Domínio operator-daily-ritual (1) ─────────────────────────────────
    // S3 Abertura e Fechamento do dia — GET /v1/agent-dashboard/day-ritual,
    // molde AgentDashboardAggregatorService. Opt-in, gateia o fetch (13/Jul/2026).
    {
        code: 'operator-daily-ritual',
        tierMin: 'solo',
        description: 'Rito de Abertura e Fechamento do dia (Corrente de Compromissos S3) — o dia do operador ganha fronteiras finitas. Abertura (`kind=opening`): «Vence hoje» (compromissos + pendências + agendamentos), «A IA resolveu — com prova» (conversas fechadas pela IA desde o último pouso, com desfecho legível) e «Só você decide» (escalações aguardando + propostas de transição pendentes). Fechamento (`kind=closing`, espelho): «O que o dia provou», «Rola para amanhã» (carry-over honesto) e «A IA cobre a noite» (conversas H_c ativas do tenant). Composição read-time user-scoped (molde `AgentDashboardAggregatorService`, fan-out `Promise.allSettled`, cada bloco degrada isolado para `null`). Sem tabela nova — `since` opcional no request; `lastRitualAt` v1 é client-side (localStorage). Solo+ universal; opt-in real via CapabilityEntry (gateia o fetch, não só o render).',
        auditSeverity: 'info',
        category: 'coordination',
        appliesTo: 'user',
        optInRequired: true,
    },
    // ─── Domínio client-engagement (1) ─────────────────────────────────────
    // S4 PR-a — política de atuação da IA por-cliente (BondParticipant.aiEngagementMode).
    // no_engage força H_a / bloqueia turno; welcome_only inerte (pendente-de-choke);
    // engage=atual. Opt-in por-tenant; sem a cap o motor ignora o campo (13/Jul/2026).
    {
        code: 'client-ai-engagement-policy',
        tierMin: 'solo',
        description: `Política de ATUAÇÃO da IA por-cliente (Corrente de Compromissos S4, Item 404 faceta b). Marca \`BondParticipant.aiEngagementMode\`: 'no_engage' (a IA nunca atua com este cliente — a conversa nasce/segue H_a, o operador conduz), 'welcome_only' (a IA só acolhe e passa a um humano — armazenado mas ainda inerte no motor, pendente-de-choke) ou 'engage' (atua normalmente). Dois plugs determinísticos defense-in-depth: o nascimento do modo (RoutingService) rebaixa a H_c→H_a quando 'no_engage'; o ConductorInboundListener bloqueia o turno em H_c quando a política mudou após o nascimento. O gate de identidade/verificação roda como sempre (política de engajamento ≠ bypass de identidade). OPT-IN via CapabilityEntry (tenant); sem a cap o motor ignora o campo (byte-idêntico). Edição via PATCH /v1/bonds/:bondId/participants/:id (audit bond.participant.engagement-mode-changed).`,
        auditSeverity: 'info',
        category: 'ai',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    // ─── Domínio proactive-work-suggestions (1) ───────────────────────────
    // S5 — motor gerador on-demand GET /v1/agent-dashboard/low-tide-suggestions
    // (M6 pendência vencida + M7 sentimento em queda), sem tabela nova. Opt-in
    // por-tenant, gateia o fetch (13/Jul/2026).
    {
        code: 'proactive-work-suggestions',
        tierMin: 'solo',
        description: 'Maré baixa produtiva (Corrente de Compromissos S5, Item 405) — motor de geração de demanda sobre o ativo conversacional. `GET /v1/agent-dashboard/low-tide-suggestions` computa on-demand (sem tabela nova) até 3 sugestões: M6 (Pendency vencida do operador, incl. compromissos conversacionais do S2) e M7 (conversa do operador com sentimento em queda). Ranking puro determinístico (urgência × alcance ÷ custo do toque). Guardrails de código: opt-out da Person nunca gera sugestão de contato; cadência de 48h por Person após aceite/dispensa (audit-derived); mina com ≥3 dispensas em 7d encolhe para aquele operador. Superfície: card na maré baixa da Corrente (Painel V3) com os gestos «fazer agora» / «delegar à IA» (quando há conversa aberta E a cap `ai-step-delegation` está ativa) / «agora não» (dismiss, audita e suprime 48h). Solo+ universal; opt-in real via CapabilityEntry (gateia o fetch, não só o render).',
        auditSeverity: 'info',
        category: 'coordination',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    // ─── Domínio operational (1) ───────────────────────────────────────────
    // Sprint Backend Operacional Agent Z — Pendency ADR-109 (Brief 2A r7b §17).
    // Team+ via tier-filter (operação peer-coordinated; Solo não recebe).
    {
        code: 'pendencies',
        tierMin: 'team',
        description: 'Gestão de Pendências do atendente (ADR-109) — ações que dependem do operador humano (NÃO compromissos do cliente; NÃO agendamentos). Lifecycle open → in_progress → resolved | cancelled | expired. Listagem por conversa + por usuário (painel pessoal). Mutations exigem If-Match (ADR-071).',
        auditSeverity: 'info',
        category: 'conversation',
        appliesTo: 'user',
    },
    // ─── PR S18 — Brief 3 Supervisor backend bundle (Onda 1 paralelo) ────
    // Foundation Princípio 3.6 Brief 3 V2 — supervisor customiza filtros,
    // sensitivity, defaults; estado persiste. PRs S1/S2/S3/S9/S10/S13 consomem.
    {
        code: 'user-preferences-manage',
        tierMin: 'solo',
        description: 'Persistir preferências individuais do usuário (filtros, sensitivity, defaults, widget-layout) via 4 endpoints REST canonical. Cada usuário lê/escreve somente suas próprias prefs. Foundation Princípio 3.6 Brief 3 V2 — Painel Supervisor consome (S1/S2/S3/S9/S10/S13).',
        auditSeverity: 'info',
        category: 'supervision',
        appliesTo: 'user',
    },
    // ─── PR S16 — Brief 3 Supervisor backend bundle (Onda 1 paralelo) ────
    // agent-performance-read Pro+ — Dashboard Qualidade S3 + gestor-insight S9.
    {
        code: 'agent-performance-read',
        tierMin: 'professional',
        description: 'Ler métricas agregadas de performance dos agentes IA (acceptanceRate, tokens, custo, latência) por dia e por cenário. Dashboard Qualidade S3 + gestor-insight-agent S9 consomem. Endpoint manual POST /v1/agents/invocations/:id/acceptance também gated nesta capability.',
        auditSeverity: 'info',
        category: 'supervision',
        appliesTo: 'user',
    },
    // ─── Domínio Lume-internal (1) ─────────────────────────────────────────
    {
        code: 'lume-internal-capability-management',
        tierMin: 'professional',
        description: 'Gestão do catálogo de capabilities pela NetComet Soluções (admins internos).',
        auditSeverity: 'forensic',
        category: 'capability',
        appliesTo: 'user',
        isInternal: true,
    },
    // ─── Domínio mcp-tool (1) — Sub-fatia 10.0 PR 2 (ADR-142) ─────────────
    // Solo+ opt-in default OFF — regra do silêncio: tenants sem capability
    // jamais veem menção a conector externo na UI nem disparam audit MCP.
    {
        code: 'external-context-sync',
        tierMin: 'solo',
        description: 'Permite tenant cadastrar conectores externos MCP para enriquecer o contexto do cliente (snapshot de bond/person/participants do ERP/CRM externo). Default OFF em todos os planos; opt-in via /admin/integrations (Item 308 — Sprint A4 S1). Regra do silêncio: tenants sem esta capability jamais veem menção a conector externo na UI nem disparam audit MCP. SuperGer é o primeiro consumidor do contrato canonical; outros parceiros (Bling, ERPNext, sistema municipal) plugam sem código novo no Engine.',
        auditSeverity: 'info',
        category: 'mcp-tool',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    // ─── Domínio admin-integrations (2) — Sprint A4 S1 PR 1 ──────────────
    // Solo+ manage / Regulated read — gestão de integrações externas via
    // /admin/integrations (S1 ERPs+CRMs MCP; S2-S5 conforme materializam).
    {
        code: 'integrations-manage',
        tierMin: 'solo',
        description: 'Permite admin do tenant cadastrar, editar, pausar e remover integrações externas via /admin/integrations. Cobre todos sub-projetos S1-S5 da Sprint A4 conforme materializam. v1 (S1) cobre conectores MCP (ERPs/CRMs externos).',
        auditSeverity: 'high',
        category: 'admin',
        appliesTo: 'user',
    },
    {
        code: 'integrations-read',
        tierMin: 'regulated',
        description: 'Permite DPO visualizar /admin/integrations em read-only para auditoria LGPD. Vê lista de conectores, status, audit history. Não vê credentials, não pode editar/criar/deletar.',
        auditSeverity: 'info',
        category: 'admin',
        appliesTo: 'user',
    },
    // ─── Domínio playbook-persona (4) — Fase 2 PR S1 ──────────────────────
    // Playbook CRUD (ADR-029 + ADR-031 + Caderno cap 22) — gestão da estratégia
    // conversacional por tenant. author (gestor+admin_tenant Team+) + read (Solo+ universal).
    {
        code: 'playbook-author',
        tierMin: 'team',
        description: 'Permite criar/editar/deletar Playbook do tenant via CRUD REST. Roles: gestor + admin_tenant. Audit high (mudanças em estratégia conversacional).',
        auditSeverity: 'high',
        category: 'ai',
        appliesTo: 'tenant',
    },
    {
        code: 'playbook-read',
        tierMin: 'solo',
        description: 'Permite ler Playbook do tenant. Todo papel autenticado tem acesso (gestor visualiza para configurar; atendente inspeciona).',
        auditSeverity: 'info',
        category: 'ai',
        appliesTo: 'tenant',
    },
    // Persona CRUD (ADR-025 + Caderno cap 23) — voz/tom/ética da IA por tenant.
    // author (gestor+admin_tenant Team+) + read (Solo+ universal).
    {
        code: 'persona-author',
        tierMin: 'team',
        description: 'Permite criar/editar/deletar Persona do tenant. Roles: gestor + admin_tenant. Audit high (voz/tom da IA).',
        auditSeverity: 'high',
        category: 'ai',
        appliesTo: 'tenant',
    },
    {
        code: 'persona-read',
        tierMin: 'solo',
        description: 'Permite ler Persona do tenant. Todo papel autenticado tem acesso.',
        auditSeverity: 'info',
        category: 'ai',
        appliesTo: 'tenant',
    },
    // Fase 2 «Conduta e Contexto» — LEITURA da conduta resolvida: os 5 eixos com valor
    // efetivo + a origem na cascata Persona ▸ Playbook ▸ Tenant ▸ plataforma. Solo+.
    {
        code: 'ai-conduct-profile-read',
        tierMin: 'solo',
        description: 'Permite ler a CONDUTA RESOLVIDA da IA — os 5 eixos com o valor efetivo, a origem de cada um na cascata Persona ▸ Playbook ▸ Tenant ▸ plataforma, e o motivo quando um nível existe no banco mas o motor não o consulta. Gate de LEITURA das 3 telas de conduta (aba do Tenant, aba do Playbook, seção da Persona). A ESCRITA continua gateada pela cap da casa de cada nível (tenant-config-manage / playbook-author / persona-author) — quem edita a conduta de um playbook não é necessariamente quem edita a do tenant inteiro. Não reusa tenant-config-read de propósito: um autor de playbook/persona precisa VER de onde vem o eixo que está sobrepondo, sem poder ler a config do tenant. tier_min solo: entender de onde vem a conduta da própria IA é direito de qualquer tenant, inclusive o profissional autônomo — é o oposto de um upsell.',
        auditSeverity: 'debug',
        category: 'ai',
        appliesTo: 'user',
    },
    // ─── Domínio routing (1) — Fase 2 PR S3 ───────────────────────────────
    // Roteamento automático inbound: regras declarativas (RoutingRule[]) +
    // LLM Haiku fallback + algoritmo de seleção de atendente. Team+.
    {
        code: 'ai-routing',
        tierMin: 'team',
        description: 'Roteamento automático de conversa inbound para playbook + grupo + atendente apropriado. Híbrido: regras declarativas (RoutingRule[]) primeiro + LLM Haiku fallback se regras ambíguas + algoritmo determinístico de seleção de atendente. Team+ via tier-filter.',
        auditSeverity: 'info',
        category: 'ai',
        appliesTo: 'tenant',
    },
    // ─── Domínio out-of-hours (1) — PR S5 Fase 2 ──────────────────────────
    // Auto-resposta fora do horário comercial (ADR-029 Eixo F). Team+ opt-in
    // default OFF. Configuração via Tenant.businessHours + outOfHoursMessage.
    {
        code: 'auto-reply-out-of-hours',
        tierMin: 'team',
        description: 'Auto-resposta automática quando mensagem inbound chega fora do horário comercial do tenant AND zero atendentes online. Template configurável via Tenant.outOfHoursMessage (placeholders {tenantName} e {nextOpenAt}). Horário definido em Tenant.businessHours (array [{dayOfWeek, openHour, closeHour}]). Default OFF — opt-in pelo admin do tenant via /admin/settings. Team+ via tier-filter. ADR-029 Eixo F.',
        auditSeverity: 'info',
        category: 'conversation',
        appliesTo: 'tenant',
    },
    // ─── Backfill drift (Brief 4 V2 Telas 3+9 — v3.232-236) ───────────────
    // Templates Meta WhatsApp (HSM) + Configuração de Bonds por tenant.
    // Telas do Gestor; admin_tenant herda via extends. tierMin solo (core).
    {
        code: 'message-template-read',
        tierMin: 'solo',
        description: 'Ler o catálogo de templates Meta WhatsApp (HSM) do tenant — nome, categoria, status de aprovação Meta, variáveis. Tela do Gestor.',
        auditSeverity: 'debug',
        category: 'conversation',
        appliesTo: 'tenant',
    },
    {
        code: 'message-template-manage',
        tierMin: 'solo',
        description: 'Criar/editar/descontinuar templates Meta WhatsApp (HSM) e submetê-los à Meta (DRAFT→PENDING→APPROVED/REJECTED). Tela do Gestor.',
        auditSeverity: 'info',
        category: 'conversation',
        appliesTo: 'tenant',
    },
    {
        code: 'bond-type-config-read',
        tierMin: 'solo',
        description: 'Ler o catálogo canônico de tipos de Bond mesclado com o estado ativo do tenant (quais tipos estão habilitados + contagem de Bonds por tipo). Tela do Gestor.',
        auditSeverity: 'debug',
        category: 'conversation',
        appliesTo: 'tenant',
    },
    {
        code: 'bond-type-config-manage',
        tierMin: 'solo',
        description: 'Ativar/desativar tipos de Bond canônicos na operação do tenant (toggle por tipo). Tela do Gestor.',
        auditSeverity: 'info',
        category: 'conversation',
        appliesTo: 'tenant',
    },
    // ─── Domínio canned-responses (4) — Respostas Prontas do Operador S1+S4 ──
    // Biblioteca de respostas prontas do tenant (rajada texto+mídia) +
    // biblioteca de mídia. Opt-in real FORA de pacote ⇒ merge INERTE.
    {
        code: 'canned-response-use',
        tierMin: 'solo',
        description: 'Operador vê a biblioteca de Respostas Prontas do tenant e envia pela conversa (picker + fila de revisão — S2). Na S1 gateia a leitura (GET /v1/canned-responses).',
        auditSeverity: 'info',
        category: 'conversation',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    {
        code: 'canned-response-manage',
        tierMin: 'solo',
        description: 'Gestor/supervisor administra a biblioteca de Respostas Prontas (CRUD + vínculos a playbooks). Tela /configuracao/quick-replies (gate-and-split sobre o catálogo legado do Brief 4).',
        auditSeverity: 'info',
        category: 'conversation',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    {
        code: 'media-library-manage',
        tierMin: 'solo',
        description: 'Upload e gestão de assets de mídia do tenant (imagem/vídeo/áudio) para uso em Respostas Prontas. Storage S3-compatible (MinIO dev / Ceph prod), lifecycle ADR-092 (archived → purge).',
        auditSeverity: 'info',
        category: 'conversation',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    {
        code: 'canned-response-analytics',
        tierMin: 'solo',
        description: 'Supervisor/gestor vê métricas de uso das Respostas Prontas por operador (% de mensagens via resposta pronta, taxa de edição antes do envio, top respostas, distribuição por categoria — computadas do rastro em Message.metadata, nunca contador paralelo) e configura os alertas de conduta (limiar/janela). Alerta é SINAL para conversa de gestão, nunca punição automática nem bloqueio de envio; default desligado (opt-in). S4.',
        auditSeverity: 'info',
        category: 'conversation',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    // ─── Domínio voice-dictation (1) — frente voz/STT Fase 1 (18/Jul/2026) ──
    // Ditado do operador no composer mobile — POST /v1/transcriptions. Opt-in
    // real FORA de pacote ⇒ merge INERTE. Áudio efêmero (sem persistência).
    {
        code: 'voice-dictation',
        tierMin: 'solo',
        description: 'Operador dita no composer mobile e recebe texto transcrito de volta (frente voz/STT, Fase 1). Gateia `POST /v1/transcriptions` — transcrição SERVER-SIDE, áudio EFÊMERO (nunca persiste), SEM pseudonimização (o operador compõe a própria mensagem antes de enviar). Sem backend STT configurado (`STT_BASE_URL`) → 503 honesto.',
        auditSeverity: 'info',
        category: 'conversation',
        appliesTo: 'user',
        optInRequired: true,
    },
    // ─── PR S17 — Brief 3 Supervisor backend bundle (Onda 1 paralelo) ─────
    // NotificationService multi-channel (Q10 brainstorming) — in-app + email reais
    // + push plug ready. Foundation usada por todas as ondas 2-9 do bundle.
    // notifications-manage: Solo+ default ON — todo user gerencia próprias prefs/inbox.
    // notifications-send: Pro+ default OFF — admin direct-send via REST (opt-in explícito).
    // notifications-admin: Pro+ default OFF — view cross-user (analytics) supervisor+.
    {
        code: 'notifications-manage',
        tierMin: 'solo',
        description: 'Gerenciar próprias notificações (listar, marcar lida, configurar preferências per channel × template). Cada usuário lê/escreve somente suas próprias notifications/prefs (defense-in-depth via JWT @UserId). 6 endpoints user-facing /v1/me/notifications + /v1/me/notification-preferences. Solo+ default ON — toda role tenant herda (atendente cascateia via extends).',
        auditSeverity: 'info',
        category: 'supervision',
        appliesTo: 'user',
    },
    {
        code: 'notifications-send',
        tierMin: 'professional',
        description: 'Despachar notificações arbitrárias via POST /v1/notifications/send (admin/system direct-send para 1+ recipients). Pro+ default OFF (opt-in explícito). Útil para integrações administrativas + scripts ad-hoc + smoke email real. Callers internos (workers, listeners, agentes) NÃO passam por este endpoint — injetam o service diretamente.',
        auditSeverity: 'info',
        category: 'supervision',
        appliesTo: 'user',
    },
    {
        code: 'notifications-admin',
        tierMin: 'professional',
        description: 'Visualizar notifications de todos os usuários do tenant (analytics + forensic). Pro+ default OFF (opt-in explícito). Endpoint manual + dashboard analítico futuro consomem. NÃO inclui leitura cross-tenant (multi-tenant isolation absoluto).',
        auditSeverity: 'info',
        category: 'supervision',
        appliesTo: 'user',
    },
    // ─── PR S1 — Brief 3 Supervisor backend bundle (Onda 2 paralelo) ──────
    // Pendency enhanced — vista supervisória do time (Tela 4 Inbox do Time).
    // pendency-team-read: Team+ default ON supervisor+ — lista/heatmap/export/aggregation.
    // pendency-bulk-operations: Team+ default ON supervisor+ — bulk reassign/postpone ACID.
    {
        code: 'pendency-team-read',
        tierMin: 'team',
        description: 'Visualização da Inbox do Time (Tela 4 Brief 3 V2) — 4 views canonical (operator/category/timeline/heatmap) + top metrics + export CSV streaming. Endpoints /v1/team/pendencies/* (GET + export). Não modifica Pendency canonical; opera sobre agregações + materialized cache (heatmap refresh cron 30min).',
        auditSeverity: 'info',
        category: 'supervision',
        appliesTo: 'user',
    },
    {
        code: 'pendency-bulk-operations',
        tierMin: 'team',
        description: 'Operações em massa sobre Pendency (max 100 items canonical Q13=A): bulk-reassign (transação ACID) + bulk-postpone (limite postponeCount<3 ADR-109) + escalate (via User.reportsToUserId hierarquia W2.1). Endpoints PATCH /v1/team/pendencies/bulk-reassign + /bulk-postpone + POST /:id/escalate. Audit canonical severity=high para reassign + escalate; severity=info para postpone + limit-reached.',
        auditSeverity: 'high',
        category: 'supervision',
        appliesTo: 'user',
    },
    // ─── PR S2 — Brief 3 Supervisor backend bundle (Onda 2) ──────────────
    // SLA module canonical (Tela 5 Painel SLA).
    // sla-read: Team+ default ON supervisor+ — dashboard/heatmap/ranking/drill-down.
    // sla-manage: Team+ default ON supervisor+ — CRUD SlaDefinition + If-Match.
    // sla-pattern-detection: Pro+ default ON supervisor+ — rolling 14d pattern detection + ack.
    {
        code: 'sla-read',
        tierMin: 'team',
        description: 'Visualização do Painel de SLA (Tela 5 Brief 3 V2) — dashboard cards cumprimento per slaType + heatmap dayOfWeek×hourPeriod + operator ranking + drill-down breaches paginated. Endpoints GET /v1/sla/definitions + GET /v1/sla/dashboard/*. Read-only; não modifica SlaDefinition canonical.',
        auditSeverity: 'info',
        category: 'supervision',
        appliesTo: 'user',
    },
    {
        code: 'sla-manage',
        tierMin: 'team',
        description: 'CRUD SlaDefinition (Tela 5 Painel SLA — editor). Create/update/delete com If-Match canonical (ADR-071 OptimisticLockException). Endpoints POST/PATCH/DELETE /v1/sla/definitions. Audit canonical severity=high para create/update/delete (mudança de threshold afeta cron breach detection).',
        auditSeverity: 'high',
        category: 'supervision',
        appliesTo: 'user',
    },
    {
        code: 'sla-pattern-detection',
        tierMin: 'professional',
        description: 'Detecção automática de padrões temporais SLA (rolling 14d window). Cron daily flag (dayOfWeek, hourPeriod) buckets com cumprimento <85% em 2+ semanas. Persiste SlaTemporalPattern; supervisor acknowledges via PATCH /v1/sla/dashboard/patterns/:id/dismiss. Endpoints GET /v1/sla/dashboard/patterns + PATCH .../:id/dismiss. Pro+ apenas — analítico/preditivo (Solo/Team não recebem). Regra do silêncio: cron NÃO roda em tenants sem capability granted.',
        auditSeverity: 'info',
        category: 'supervision',
        appliesTo: 'user',
    },
    // ─── PR S13 — Brief 3 Supervisor backend bundle (Onda 3) ─────────────
    // CoAttendance enhanced (Tela 2 Acompanhamento Silencioso Brief 3 V2 §7).
    // 4 capabilities granulares (foundation peer-coordination-co-attendance
    // ADR-049 inalterada):
    // coattendance-shadow-observer: Team+ default ON supervisor+ — modo padrão visível.
    // coattendance-invisible-to-all: Regulated only via tier-filter — opt-in justification.
    // coattendance-collaborative-observer: Pro+ via tier-filter — modo treinamento.
    // supervisor-session-notes: Team+ default ON supervisor+ — auto-save notas privadas.
    {
        code: 'coattendance-shadow-observer',
        tierMin: 'team',
        description: 'CoAttendance modo shadow_observer (Tela 2 Acompanhamento Silencioso Brief 3 V2 §7). Supervisor vê em tempo real + chat lateral coaching + force-takeover, NÃO mensageia cliente. Banner público de monitoring visível (Q17 cultura sadia). Default modo operacional do supervisor — Q16=A visible-to-attendant.',
        auditSeverity: 'info',
        category: 'coordination',
        appliesTo: 'user',
    },
    {
        code: 'coattendance-invisible-to-all',
        tierMin: 'regulated',
        description: 'CoAttendance modo supervisor_monitor (invisible-to-all). Q17 Regulated policy: cliente + atendente NÃO veem indicador algum; supervisor observa silenciosamente. Default OFF — admin tenant Regulated habilita opt-in com justification mandatory por request (audit severity=high + audit canonical coattendance.invisible-mode-entered severity=high). Chat lateral + force-takeover DESABILITADOS para preservar opacidade. `opt_in_required: true` — cultura sadia: tenant Regulated NÃO ganha invisible mode automaticamente; requer gesto admin explícito via CapabilityEntry per-tenant (Q17 spec policy + ADR-118 + Item 312 Sprint A4 S1).',
        auditSeverity: 'high',
        category: 'coordination',
        appliesTo: 'user',
        optInRequired: true,
    },
    {
        code: 'coattendance-collaborative-observer',
        tierMin: 'professional',
        description: 'CoAttendance modo collaborative_observer (Tela 2 — treinamento com cliente ciente). Pro+ tier. Supervisor PODE mensagear cliente diretamente (autor marcado), banner público de monitoring + chat lateral + force-takeover habilitados. Use case principal: sênior treina júnior em atendimento real.',
        auditSeverity: 'info',
        category: 'coordination',
        appliesTo: 'user',
    },
    {
        code: 'supervisor-session-notes',
        tierMin: 'team',
        description: 'Notas privadas auto-save 5s do supervisor durante CoAttendance (Tela 2). Persistem per (coAttendance × supervisor) — UNIQUE composite. Channel isolation crítica: emit DIRECIONADO via emitToUser(supervisorUserId) — outros usuários no tenant NÃO veem notas privadas. Audit canonical supervisor-session-note.created severity=info apenas em first persist (throttled updates não geram spam).',
        auditSeverity: 'info',
        category: 'coordination',
        appliesTo: 'user',
    },
    // ─── PR S11 — Brief 3 Supervisor backend bundle (Onda 3) ─────────────
    // Force-Takeover canonical. Endpoint reutilizado em 3 telas (2/3/8).
    // 2 capabilities granulares:
    // - force-takeover: Team+ default ON supervisor+ — gate dos 3 endpoints.
    // - force-takeover-bypass-coattendance: Regulated opt_in_required — break-glass override.
    {
        code: 'force-takeover',
        tierMin: 'team',
        description: 'Force-Takeover canonical (Tela 2 Acompanhamento + Tela 3 Intervenção + Tela 8 P1 Brief 3 V2). Supervisor assume conv ativa do atendente original via reason ≥20 chars; H_c → H_a transition + AIConductor.pauseInferenceFor; atendente original perde write access via ConversationsService.assertCanWrite defensive check. Audit severity=high. Return + Transfer reutilizam mesmo gate. Modo invisible-to-all PRIOR NÃO vaza para novo atendente (Brief 3 §8.5.4 — silent invisible-to-all).',
        auditSeverity: 'high',
        category: 'coordination',
        appliesTo: 'user',
    },
    {
        code: 'force-takeover-bypass-coattendance',
        tierMin: 'regulated',
        description: 'Force-Takeover break-glass override para Tela 3 Intervenção em Regulated. `opt_in_required: true` — cultura sadia: tenant Regulated NÃO ganha bypass automaticamente; requer gesto admin explícito via CapabilityEntry per-tenant (S13 pós-review #1 pattern + ADR-118 + Item 312 Sprint A4 S1). v1 gate-only (audit forensic markers em logs futuros); service layer não diferencia. Capability declarada para audit + UI gates futuros (banner "modo emergência" em Tela 3).',
        auditSeverity: 'high',
        category: 'coordination',
        appliesTo: 'user',
        optInRequired: true,
    },
    // ─── Atribuir conversa (sub-projeto 1, varredura telas) ──────────────
    // conversation-assign: Team+ default ON supervisor+ — atribui/reatribui
    // UMA conversa a um atendente do escopo. Distinto de force-takeover.
    {
        code: 'conversation-assign',
        tierMin: 'team',
        description: 'Permite ao supervisor (Team+) atribuir/reatribuir UMA conversa a um atendente do seu escopo de supervisão (getSupervisionScope). Push direto: seta Conversation.assignedToUserId, resolve escalation pendente, notifica o novo dono (e o anterior na reatribuição), audita severity=high. NÃO toca operationMode (atribuir dono é ortogonal a conduzir). Distinta de force-takeover (não assume a conversa). Reusada pelo Item 330 (P1).',
        auditSeverity: 'high',
        category: 'coordination',
        appliesTo: 'user',
    },
    // ─── PR S12 — Brief 3 Supervisor backend bundle (Onda 3) ─────────────
    // Force-Playbook-Switch canonical. Endpoint reutilizado em 3 telas (2/3/8).
    // 1 capability granular gate dos 2 endpoints:
    // - force-playbook-switch: Team+ default ON supervisor+
    {
        code: 'force-playbook-switch',
        tierMin: 'team',
        description: `Force-Playbook-Switch canonical (Tela 2 espelho + Tela 3 Intervenção + Tela 8 P1 Brief 3 V2). Supervisor (Team+) força troca de playbook canonical em conv ativa via reason ≥20 chars; transação ACID atualiza Conversation.playbookId + cria PlaybookChangeHistory row (autoOrManual='manual_supervisor') foundation para análise derivas conversacionais (Tela 6 — consume por PR S3 Quality Aggregations futuro). AIConductor consume evento via @OnEvent listener canonical para reset contexto IA. Audit severity=high. Gate dos 2 endpoints (GET available-playbooks + POST force-playbook-switch).`,
        auditSeverity: 'high',
        category: 'coordination',
        appliesTo: 'user',
    },
    // ─── S6 — Condução Governada (Q-J8) ───────────────────────────────────
    // playbook-manual-switch: Team+ default ON atendente — troca manual SOB a matriz
    // transitionPolicy (distinta do force-playbook-switch, que a IGNORA).
    {
        code: 'playbook-manual-switch',
        tierMin: 'team',
        description: `Troca manual de playbook pelo atendente comum (S6 — Condução Governada, Q-J8). Endpoint \`POST /v1/conversations/:id/playbook-switch\` — HONRA a matriz \`transitionPolicy\` declarada (par \`blocked\` → 422) + hard blocks (adversarial strict / ConflictAlert ativo → 422); par \`requires_confirmation\` ou sem par declarado PERMITE direto (a ação já é humana — exigir confirmação de si mesmo seria circular). NÃO toca \`operationMode\` (espelho: só playbookId). History \`PlaybookChangeHistory.autoOrManual='manual_attendant'\` (enum já existente no schema, nunca escrito até esta frente). Poder NOVO de front-line — Regulated/tenants conservadores podem desligar o atendente sem desligar o supervisor (que segue com force-playbook-switch). Inalcançável na operação até a UI nascer na S7 (sem botão até lá).`,
        auditSeverity: 'high',
        category: 'coordination',
        appliesTo: 'user',
        optInRequired: true,
    },
    // ─── Frente engine-led S7 — sinal de foco + alerta cliente-em-espera ──
    // conversation-viewing-awareness: Team+ opt-in por-tenant fora de pacote — o
    // operador sinaliza foco; alerta honra operatorNotificationPolicy.
    {
        code: 'conversation-viewing-awareness',
        tierMin: 'team',
        description: 'Consciência de foco por-conversa (Frente engine-led S7 — Condução Governada). Peça 1: o operador sinaliza que ABRIU/FECHOU a Conversa (endpoint POST conversations/:id/viewing); o Engine guarda o estado com TTL (ConversationViewingService) e emite `conversation.attendant-viewing` dirigido a observers (molde do composing). Peça 3: quando uma conversa ATRIBUÍDA a um humano (fora de H_c) recebe mensagem do cliente E o operador responsável NÃO está com ela aberta, dispara o alerta `conversation-customer-waiting` (in-app + push) pela máquina de notificação N1/N2 — honrando quiet-hours/escala de plantão (`operatorNotificationPolicy`). Supressão da IA no choke (segurar o turno enquanto o humano olha) fica FORA desta cap (decisão de produto pendente).',
        auditSeverity: 'info',
        category: 'coordination',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    // ─── PR S14 — Brief 3 Supervisor backend bundle (Onda 4) ─────────────
    // BehavioralPatternDetection canonical. Foundation Dashboard Qualidade (Tela 6).
    // Q12=A leve+pesada+drill. Q17=A NO operator notification on detect.
    // 3 capabilities granulares — gate dos 10 endpoints REST:
    // - behavioral-pattern-read: Pro+ default ON supervisor+ — list/find/drill-down/team-summary.
    // - behavioral-pattern-contest: Solo+ default ON atendente — self-defense.
    // - behavioral-pattern-review: Pro+ default ON supervisor+ — dismiss/archive/review/feedback.
    {
        code: 'behavioral-pattern-read',
        tierMin: 'professional',
        description: 'BehavioralPattern read (Tela 6 Dashboard de Qualidade + drill-down). Supervisor (Pro+) acessa list + find + drill-down + team-summary + list contestations. Q12=A canonical — análise pesada agregada via cron 5h consumida em UI. Brief 3 §11.8 Pro+ requirement.',
        auditSeverity: 'info',
        category: 'supervision',
        appliesTo: 'user',
    },
    {
        code: 'behavioral-pattern-contest',
        tierMin: 'solo',
        description: 'BehavioralPattern contestation (atendente). Tier=Solo+ canonical — TODO atendente sempre pode contestar pattern atribuído a ele (self-defense direito incondicional). Workflow: pattern.status=under_review até supervisor revisar. Notifica supervisor via NotificationsService.',
        auditSeverity: 'high',
        category: 'supervision',
        appliesTo: 'user',
    },
    {
        code: 'behavioral-pattern-review',
        tierMin: 'professional',
        description: 'BehavioralPattern review (supervisor). Tier=Pro+ default ON supervisor+. Gate dos 4 endpoints write: dismiss / archive / review contestations / submit feedback. Workflow contestation: upheld → pattern dismissed; overturned → pattern preservado active. Feedback retraining loop ao behavioral-agent v2 (futuro).',
        auditSeverity: 'high',
        category: 'supervision',
        appliesTo: 'user',
    },
    // ─── PR S3 — Brief 3 Supervisor backend bundle (Onda 4 — 2º/final) ──
    // Quality Aggregations canonical. Dashboard Qualidade backend (Tela 6 §4.4.2).
    // 6 materialized + 4 crons + 8 services consumindo cross-module.
    // 3 capabilities granulares — gate dos 12 endpoints REST:
    // - quality-aggregations-read: Pro+ default ON supervisor+ — 9 read endpoints.
    // - quality-aggregations-export: Pro+ default ON supervisor+ — CSV streaming.
    // - quality-coach-scheduling: Pro+ default ON supervisor+ — agenda coaching session.
    {
        code: 'quality-aggregations-read',
        tierMin: 'professional',
        description: 'Quality Aggregations read (Tela 6 Dashboard de Qualidade). Supervisor (Pro+) acessa 9 reads: global / by-operator / by-playbook / drill-down / agents performance / sequences flags / playbook-drift / heatmap / sparkline / baseline-compare. Foundation Item 110.',
        auditSeverity: 'info',
        category: 'supervision',
        appliesTo: 'user',
    },
    {
        code: 'quality-aggregations-export',
        tierMin: 'professional',
        description: 'Quality Aggregations export CSV. Supervisor (Pro+) baixa OperatorQualityMetricsDaily filtered/streamed via cursor pagination. Audit canonical quality.export-csv info per call.',
        auditSeverity: 'info',
        category: 'supervision',
        appliesTo: 'user',
    },
    {
        code: 'quality-coach-scheduling',
        tierMin: 'professional',
        description: 'Quality coach session scheduling. Supervisor (Pro+) agenda sessão de coaching com atendente. Notifica operador via NotificationsService (template quality-coach-scheduled). Audit canonical quality.coach-scheduled high.',
        auditSeverity: 'high',
        category: 'supervision',
        appliesTo: 'user',
    },
    // ─── PR S5 — Brief 3 Supervisor backend bundle (Onda 5 — 1º) ────────────
    // ConflictAlert lifecycle 7 estados canonical + ChainDetector + MCP blocking.
    // 4 capabilities granulares — gate dos 12 endpoints REST:
    // - conflict-alert-mitigate: Team+ default ON supervisor+ — mitigate + false-positive.
    // - conflict-alert-accept-with-justification: Pro+ default ON supervisor+ — accept-with-justification.
    // - conflict-alert-resolve-or-revoke: Regulated opt_in_required — break-glass forensic.
    // - mcp-blocking-bypass: Regulated opt_in_required — break-glass MCP override.
    {
        code: 'conflict-alert-mitigate',
        tierMin: 'team',
        description: `Mitigate ConflictAlert + mark-false-positive. Supervisor (Team+) registra ação corretiva (advogado sai do caso, escalada interna) com evidência documental. Audit canonical 'conflict-alert.mitigated' severity=high (Regulated=forensic). Q1 spec: mitigate desbloqueia MCP + retoma conversa pausada (ACID via ConversationLifecycleService.resume).`,
        auditSeverity: 'high',
        category: 'adversarial',
        appliesTo: 'user',
    },
    {
        code: 'conflict-alert-accept-with-justification',
        tierMin: 'professional',
        description: `Accept-with-justification de ConflictAlert. Supervisor (Pro+) aceita conflito preservando trail forensic com justificativa min 100 chars (Brief 3 §12.7). Em tenant Regulated, DocumentationGated obriga >=1 documentationDocumentId. Em chainPosition >= 3, dispara DualApprovalRequest via PR S6 (placeholder audit stub Option B até PR S6 materializar). Audit 'conflict-alert.accepted-with-justification'.`,
        auditSeverity: 'high',
        category: 'adversarial',
        appliesTo: 'user',
    },
    {
        code: 'conflict-alert-resolve-or-revoke',
        tierMin: 'regulated',
        description: `Resolve/revoke ConflictAlert (Regulated only). Operações forensic preservativas do trail manual em alerts severos — admin/dpo decide finalização explícita após mitigate/accept. Default OFF — admin Regulated habilita opt-in por CapabilityEntry per-tenant (cultura sadia pattern S13 review fix #1). Audit canonical 'conflict-alert.resolved' / 'conflict-alert.revoked' severity=high (forensic em Regulated).`,
        auditSeverity: 'high',
        category: 'adversarial',
        appliesTo: 'user',
        optInRequired: true,
    },
    {
        code: 'mcp-blocking-bypass',
        tierMin: 'regulated',
        description: 'MCP blocking bypass break-glass (Regulated only). ConflictAlertBlockerMiddleware Q18=A bloqueia TODAS as tools daquela conversa quando alert critical aberto; este capability libera bypass emergencial via audit forensic obrigatório. Default OFF — admin Regulated habilita opt-in por CapabilityEntry per-tenant via justification mandatory (audit severity=high). Use cases: incidente real-time onde tool necessária para resolver crise + supervisor presente + chain de custódia.',
        auditSeverity: 'high',
        category: 'adversarial',
        appliesTo: 'user',
        optInRequired: true,
    },
    // ─── PR S4 — Brief 3 Supervisor backend bundle (Onda 5 — 2º/final) ──────
    // ConflictAlert metrics + history 90d (Tela 7 tabs Métricas + Histórico §4.5.2).
    // 1 capability granular gate dos 3 endpoints REST:
    // - conflict-alert-metrics-read: Pro+ default ON supervisor+ — metrics dashboard + history 90d + CSV export.
    {
        code: 'conflict-alert-metrics-read',
        tierMin: 'professional',
        description: `ConflictAlert metrics + history 90d reads (Brief 3 Tela 7 §4.5.2). Supervisor (Pro+) acessa tab Métricas (dashboard totais + avg mitigation time + topTypes + reincidence rate + severity distribution) + tab Histórico (90d window cursor paginated com filters type/severity/status) + export CSV streaming. Audit canonical 'conflict-alert.history-exported-csv' info severity em export endpoint (Regulated=forensic via tenant policy).`,
        auditSeverity: 'info',
        category: 'adversarial',
        appliesTo: 'user',
    },
    // ─── PR S15 — Brief 3 Supervisor backend bundle (Onda 6 — 1º) ───────────
    // Runbooks module canonical. Foundation para P1 (PR S7) e crises futuras.
    // 5 runbooks canonical seedados via migration (csam/threat/lgpd_critical/
    // incident_massive/anonymous_report). 3 capabilities granulares gate dos 8
    // endpoints REST + 4 WS events + 5 audit canonical:
    // - runbook-trigger: Team+ default ON supervisor+ — POST /v1/runbooks/:id/trigger.
    // - runbook-manage: Pro+ default ON admin_tenant — CRUD custom (canonical read-only).
    // - runbook-execution-read: Team+ default ON supervisor+ + DPO — lê executions + steps.
    {
        code: 'runbook-trigger',
        tierMin: 'team',
        description: 'Dispara execução de Runbook canonical OU custom via POST /v1/runbooks/:id/trigger. Supervisor+ default ON via tier-filter — atendente NÃO recebe (runbook é ação de crise/supervisão). Audit severity=high (csam/lgpd_critical=forensic por categoria do runbook).',
        auditSeverity: 'high',
        category: 'supervision',
        appliesTo: 'user',
    },
    {
        code: 'runbook-manage',
        tierMin: 'professional',
        description: 'CRUD de Runbook custom (tenant-owned). Canonical runbooks (tenantId=null) read-only sistema. Admin/gestor Pro+ via tier-filter. Audit severity=info em CRUD; severity high em delete (forensic preservation).',
        auditSeverity: 'info',
        category: 'supervision',
        appliesTo: 'user',
    },
    {
        code: 'runbook-execution-read',
        tierMin: 'team',
        description: 'Lê RunbookExecution + steps + log. Supervisor+ default ON via tier-filter — consulta histórico de execuções para auditoria pós-incidente. Audit severity=info em reads. DPO recebe via cascade conceitual (LGPD forensic).',
        auditSeverity: 'info',
        category: 'supervision',
        appliesTo: 'user',
    },
    // ─── PR S7 — Brief 3 Supervisor backend bundle (Onda 6 — 2º/último) ──
    // P1 module canonical. Foundation Tela 8 Painel de Gestão de P1.
    // 6 categorias canonical (csam stub Q19=A v1 + threat + level4_cross_conv +
    // conflict_alert_critical + lgpd_critical + anonymous_report). 5 capabilities
    // granulares — gate dos 12 endpoints REST + 8 WS events + 10 audit canonical:
    // - p1-read: Team+ default ON supervisor+ — list/find/escalation-chain/timeline-mini/volume-status.
    // - p1-acknowledge: Team+ default ON supervisor+ — acknowledge/handle/resolve/close.
    // - p1-escalate-chain: Pro+ default ON gestor + admin_tenant — manual override score.
    // - p1-runbook-trigger: Team+ default ON supervisor+ — trigger-runbook a partir de P1.
    // - p1-manual-flag: Pro+ opt_in_required — Regulated forensic CSAM/AnonymousReport.
    {
        code: 'p1-read',
        tierMin: 'team',
        description: 'Lê lista + detalhes de P1Incident (Tela 8). Supervisor+ default ON via tier-filter. Audit severity=info em reads.',
        auditSeverity: 'info',
        category: 'supervision',
        appliesTo: 'user',
    },
    {
        code: 'p1-acknowledge',
        tierMin: 'team',
        description: 'Acknowledge + handle + resolve + close de P1Incident (Tela 8 actions). Supervisor+ default ON via tier-filter. Audit severity=info em status transitions canonical.',
        auditSeverity: 'info',
        category: 'supervision',
        appliesTo: 'user',
    },
    {
        code: 'p1-escalate-chain',
        tierMin: 'professional',
        description: 'Escalation manual override do score canonical (Tela 8). Pro+ default ON gestor + admin_tenant. Audit severity=high em manual override (não determinístico — supervisor decisão executiva).',
        auditSeverity: 'high',
        category: 'supervision',
        appliesTo: 'user',
    },
    {
        code: 'p1-runbook-trigger',
        tierMin: 'team',
        description: 'Trigger manual de runbook a partir de P1Incident específico. Supervisor+ default ON via tier-filter. Audit severity=high (runbook é resposta coordenada de crise).',
        auditSeverity: 'high',
        category: 'supervision',
        appliesTo: 'user',
    },
    {
        code: 'p1-manual-flag',
        tierMin: 'professional',
        description: 'Manual flag de P1Incident (CSAM v1 path + AnonymousReport). Regulated forensic — sensible. Default OFF; admin Regulated habilita opt-in por CapabilityEntry per-tenant. Audit severity=forensic (LGPD chain of custody). Use cases: triagem manual de CSAM antes de PhotoDNA integrar (Q19=A v1) + canal anônimo de denúncia interna.',
        auditSeverity: 'forensic',
        category: 'supervision',
        appliesTo: 'user',
        optInRequired: true,
    },
    // ─── PR S6 — Brief 3 Supervisor backend bundle (Onda 7 — 1º) ──────────
    // Dual Approval workflow polimórfico. 4 tipos canonical (+ custom escape):
    // conflict_alert_accept (48h) / override_h_c_adversarial (24h) /
    // conversation_close_regulated (4h) / handoff_critical (1h).
    // 3 capabilities gate dos 8 endpoints REST + 6 WS events + 6 audit canonical:
    // - dual-approval-request-create: Pro+ opt_in_required (service-level usado por S5/S8/S13).
    // - dual-approval-first-approve: Team+ default ON supervisor+ — 1ª aprovação.
    // - dual-approval-second-approve: Pro+ default ON gestor + admin_tenant — 2ª aprovação terminal.
    {
        code: 'dual-approval-request-create',
        tierMin: 'professional',
        description: 'Manual create de DualApprovalRequest via POST /v1/dual-approval/requests (Onda 7 — 1º). Default OFF — uso primário é service-level (S5 ConflictAlertLifecycleService chain pos 3+, S8 OverridesService Tipo 6/8, S13 HandoffService crítico) que NÃO consome a capability. Admin habilita via CapabilityEntry per-tenant quando quiser permitir requests ad-hoc. Audit severity=high — workflow afeta operação.',
        auditSeverity: 'high',
        category: 'supervision',
        appliesTo: 'user',
        optInRequired: true,
    },
    {
        code: 'dual-approval-first-approve',
        tierMin: 'team',
        description: 'Primeira aprovação de DualApprovalRequest (POST /:id/approve em pending_first). Team+ default ON supervisor+ via tier-filter. Role validation no service layer — user.primaryRole deve matchear request.firstApproverRole. Audit severity=high (decisão executiva forensic-grade).',
        auditSeverity: 'high',
        category: 'supervision',
        appliesTo: 'user',
    },
    {
        code: 'dual-approval-second-approve',
        tierMin: 'professional',
        description: 'Segunda aprovação terminal de DualApprovalRequest (POST /:id/approve em pending_second → approved_both executa callback registry). Pro+ default ON gestor + admin_tenant. Audit severity=high (terminal forensic — dispara ação irreversível downstream via callback). 2 pessoas distintas obrigatório (Q20 spec) — service valida mesmo user não pode votar 1ª+2ª.',
        auditSeverity: 'high',
        category: 'supervision',
        appliesTo: 'user',
    },
    // ─── PR S8 — Brief 3 Supervisor backend bundle (Onda 7 — 2º/último) ──
    // Overrides module canonical — 8 tipos canonical (spec §4.7.2).
    // Tela 9 Aprovação de Overrides. 8 capabilities granulares — 1 por tipo:
    // - override-ai-required-validation: Team+ default ON supervisor+ (Tipo 1 approve-and-compose).
    // - override-carencia-proativa: Team+ default ON supervisor+ (Tipo 2 generic approve).
    // - override-gatilho-protecao: Team+ default ON supervisor+ (Tipo 3 generic approve).
    // - override-modo-operacao: Pro+ default ON gestor + admin_tenant via extends (Tipo 4).
    // - override-capability-temporaria: Pro+ opt_in_required (Tipo 5 TemporaryFeatureFlag time-boxed).
    // - override-legal-capacity-exception: Regulated opt_in_required (Tipo 6 forensic).
    // - override-conflict-alert-accept: Pro+ default ON supervisor+ (Tipo 7 chain<3 direct / >=3 dual).
    // - override-h-c-adversarial-strict: Regulated opt_in_required (Tipo 8 SEMPRE dual approval).
    {
        code: 'override-ai-required-validation',
        tierMin: 'team',
        description: 'Tipo 1 — ai_required_validation (approve-and-compose canonical). Supervisor Team+ default ON aprova override + edita texto + compõe mensagem em nome do atendente. Audit severity=high (intervenção rastreável).',
        auditSeverity: 'high',
        category: 'supervision',
        appliesTo: 'user',
    },
    {
        code: 'override-carencia-proativa',
        tierMin: 'team',
        description: 'Tipo 2 — carencia_proativa (carência proativa por situação especial). Supervisor Team+ default ON aprova override generic; sem side-effects estruturais (apenas transição pending → approved).',
        auditSeverity: 'high',
        category: 'supervision',
        appliesTo: 'user',
    },
    {
        code: 'override-gatilho-protecao',
        tierMin: 'team',
        description: 'Tipo 3 — gatilho_protecao (override de gatilho de proteção da IA). Supervisor Team+ default ON aprova override generic. Audit severity=high.',
        auditSeverity: 'high',
        category: 'supervision',
        appliesTo: 'user',
    },
    {
        code: 'override-modo-operacao',
        tierMin: 'professional',
        description: 'Tipo 4 — modo_operacao (override de modo de operação H_a/H_b/H_c/H_d). Pro+ default ON gestor + admin_tenant via extends. Audit severity=high.',
        auditSeverity: 'high',
        category: 'supervision',
        appliesTo: 'user',
    },
    {
        code: 'override-capability-temporaria',
        tierMin: 'professional',
        description: 'Tipo 5 — capability_temporaria (TemporaryFeatureFlag time-boxed). Pro+ opt_in_required (admin habilita via CapabilityEntry per-tenant). Supervisor aprova com effectiveUntil; cron 30min revoga flags expiradas. Defensive check em CapabilityResolverService honra flag (override grant).',
        auditSeverity: 'high',
        category: 'supervision',
        appliesTo: 'user',
        optInRequired: true,
    },
    {
        code: 'override-legal-capacity-exception',
        tierMin: 'regulated',
        description: 'Tipo 6 — legal_capacity_exception Regulated DocumentationGated forense. Regulated only opt_in_required. Supervisor aprova com >=1 documentationDocumentId + Guardianship ativa do Tipo C (Fatia C — ADR-050). Audit severity=forensic (Regulated chain reforçado — single-use lifecycle pending_first_use → used).',
        auditSeverity: 'forensic',
        category: 'supervision',
        appliesTo: 'user',
        optInRequired: true,
    },
    {
        code: 'override-conflict-alert-accept',
        tierMin: 'professional',
        description: 'Tipo 7 — conflict_alert_accept (aceitação canonical de ConflictAlert). Pro+ default ON supervisor+ (gestor herda via extends). Chain pos <3 finalize direto via ConflictAlertLifecycleService.acceptWithJustification. Chain pos >=3 dispara DualApprovalRequest (supervisor → gestor, 48h — PR S6 workflow paralelo). Callback registry executa lifecycle pós approved_both.',
        auditSeverity: 'high',
        category: 'supervision',
        appliesTo: 'user',
    },
    {
        code: 'override-h-c-adversarial-strict',
        tierMin: 'regulated',
        description: 'Tipo 8 — h_c_adversarial_strict (bypass adversarialMode=strict para H_c). Regulated only opt_in_required + DocumentationGated obrigatório. SEMPRE DualApprovalRequest (supervisor → gestor, 24h). Pós approved_both cria TemporaryFeatureFlag h-c-mode-strict-bypass effectiveUntil = now + 7 dias fixos (scope conversation|bond). Audit severity=high (risco regulatório).',
        auditSeverity: 'high',
        category: 'supervision',
        appliesTo: 'user',
        optInRequired: true,
    },
    // ─── PR S9 — Brief 3 Supervisor backend bundle (Onda 8) ──────────────
    // gestor-insight-agent dual-lens canonical (spec §4.8.1). Tela 10
    // Insights. 4 capabilities granulares:
    // - ai-insight-supervisor: Pro+ default ON supervisor+ (lente Supervisor afinada operational).
    // - ai-insight-gestor: Pro+ default ON gestor + admin_tenant via extends (lente Gestor estratégica).
    // - ai-insight-action: Pro+ default ON supervisor+ (5 actionType canonical via dispatcher).
    // - ai-insight-manual-trigger: Pro+ default ON supervisor+ (POST /generation/manual sob demanda).
    {
        code: 'ai-insight-supervisor',
        tierMin: 'professional',
        description: 'Acesso à lente Supervisor do gestor-insight-agent (Brief 3 Tela 10 §4.8.1). Supervisor (Pro+) lista insights filtrados por status/category/period + drill-down + accept/false-positive. Lens supervisor afinada para perguntas operacionais cotidianas. Foundation dual-lens (Q9 spec — desde v1) consume Quality (S3) + Behavioral (S14) + SLA (S2) + ConflictAlert (S5) + Sequences + AgentPerformance (S16).',
        auditSeverity: 'info',
        category: 'supervision',
        appliesTo: 'user',
    },
    {
        code: 'ai-insight-gestor',
        tierMin: 'professional',
        description: 'Acesso à lente Gestor do gestor-insight-agent (Brief 3 Tela 10 §4.8.1). Gestor (Pro+) acessa insights estratégicos de negócio (commercial / compliance / learning aggregated). Lens gestor afinada para tomada de decisão executiva. Resolve Items 116 + 128 dual-lens canonical desde v1.',
        auditSeverity: 'info',
        category: 'supervision',
        appliesTo: 'user',
    },
    {
        code: 'ai-insight-action',
        tierMin: 'professional',
        description: 'Capability para tomar ação sobre insight aceito (Brief 3 §4.8.1). Supervisor (Pro+) chama InsightActionDispatcherService — 5 actionType canonical: message_team / schedule_meeting / create_pendency_self / create_pendency_manager / coach_schedule. Resolve insight status accepted → in_action. Audit insight.action-created severity=info.',
        auditSeverity: 'info',
        category: 'supervision',
        appliesTo: 'user',
    },
    {
        code: 'ai-insight-manual-trigger',
        tierMin: 'professional',
        description: 'Capability para disparar geração manual de insights sob demanda (Brief 3 §4.8.1). Supervisor (Pro+) chama POST /v1/insights/generation/manual com body {lens}; cria InsightGenerationJob triggeredBy=manual_supervisor. Resposta retorna jobId; polling via GET /v1/insights/generation/jobs/:id.',
        auditSeverity: 'info',
        category: 'supervision',
        appliesTo: 'user',
    },
    // ─── PR S10 — Brief 3 Supervisor backend bundle (Onda 9 ÚNICA — FINAL) ──
    // Supervisor Dashboard Agregator (spec §4.9.1). Tela 1 "Mais usada".
    // 2 capabilities granulares — BUNDLE BRIEF 3 V2 100% CONCLUÍDO:
    // - supervisor-dashboard-read: Team+ default ON supervisor+ (8 endpoints REST reads + refresh trigger).
    // - supervisor-dashboard-customize: Team+ default ON supervisor+ (PUT widget preference + POST reset).
    {
        code: 'supervisor-dashboard-read',
        tierMin: 'team',
        description: 'Acesso leitura ao Painel da Equipe (Brief 3 Tela 1 §4.9.1). Supervisor (Team+) consome 8 endpoints REST canonical: GET /state (snapshot completo com ETag para polling fallback) + GET /kpis + GET /priority-queue + GET /widgets/layout + GET /snapshots/history + POST /refresh (manual trigger). Foundation da síntese cross-módulo consumindo Pendency S1 + SLA S2 + ConflictAlert S5 + P1 S7 + Overrides S8 + Insights S9 + Behavioral S14 + Sequences Fatia F + Presence Fatia G.',
        auditSeverity: 'info',
        category: 'supervision',
        appliesTo: 'user',
    },
    {
        code: 'supervisor-dashboard-customize',
        tierMin: 'team',
        description: 'Customização per-user do Painel da Equipe (Brief 3 Tela 1 §4.9.1 + Princípio 3.6 customização supervisor). Supervisor (Team+) chama PUT /v1/supervisor-dashboard/widgets/:widgetId (set position + isCollapsed + customConfig) + POST /v1/supervisor-dashboard/widgets/reset (reset to defaults). Persistido na tabela dedicada `supervisor_dashboard_widget_preferences` (UNIQUE userId+widgetId).',
        auditSeverity: 'info',
        category: 'supervision',
        appliesTo: 'user',
    },
    // ─── Item 366 — modelo de org (times/fila/roteamento Nível 1) ─────────
    // CRUD de times + membership + regras de roteamento por time. Team+.
    // team-config-read em supervisor+; team-config-manage em gestor+admin.
    {
        code: 'team-config-read',
        tierMin: 'team',
        description: 'Ler os times do tenant (modelo de org Nível 1, Item 366) + a membership de cada time. Tela Configuração → Times & Roteamento e escopo de fila do supervisor por time.',
        auditSeverity: 'debug',
        category: 'admin',
        appliesTo: 'tenant',
    },
    {
        code: 'team-config-manage',
        tierMin: 'team',
        description: 'Criar/editar/descontinuar times e gerir a membership (member/lead) + escrever as regras de roteamento por time (modelo de org Nível 1, Item 366). Admin/gestor da operação do tenant.',
        auditSeverity: 'info',
        category: 'admin',
        appliesTo: 'tenant',
    },
    // ─── Item 377 — carteira de vendedor (vínculo cliente↔operador) ───────
    // A conversa de criação nasce atribuída ao dono da carteira (antes da
    // cascata de roteamento). Team+. read em supervisor+; manage em gestor+admin.
    {
        code: 'customer-portfolio-read',
        tierMin: 'team',
        description: 'Ler a carteira de clientes por operador (vínculo cliente↔operador, Item 377): quais clientes pertencem a qual vendedor. Visão de gestão/supervisão.',
        auditSeverity: 'debug',
        category: 'admin',
        appliesTo: 'tenant',
    },
    {
        code: 'customer-portfolio-manage',
        tierMin: 'team',
        description: 'Atribuir/reatribuir/remover o vínculo cliente↔operador (carteira de vendedor, Item 377). Gestor/admin da operação do tenant.',
        auditSeverity: 'info',
        category: 'admin',
        appliesTo: 'tenant',
    },
    // ─── Item 391-B — confirmação de vínculo (fonte da verdade) ───────────
    // Operador confirma "é o titular": promove o BondParticipant de contrato
    // declarado a operator_confirmed + Identity verificada 90d. Professional+.
    {
        code: 'customer-registry-confirm',
        tierMin: 'professional',
        description: 'Confirmar "é o titular" de uma conversa (Item 391-B): promove o BondParticipant de contrato declarado a operator_confirmed + marca a Identity verificada-via-operador (TTL 90d). A confiança persiste — fecha a "coleta-que-vira-nada". Ação de operador que opera a conversa.',
        auditSeverity: 'info',
        category: 'identity',
        appliesTo: 'tenant',
    },
    // ─── Item 391-C — importação da base do tenant (CSV) ──────────────────
    // Admin importa a base: upsert idempotente promove Identity observed→
    // imported (origem autoritativa) + Bond/participant; Person divergente →
    // Pendency de reconciliação. Exclusivo admin_tenant. Professional+.
    {
        code: 'customer-registry-import',
        tierMin: 'professional',
        description: 'Importar a base de clientes do tenant (Item 391-C): admin carrega telefone/titular/CPF-CNPJ/nº de contrato/papel; upsert idempotente por linha promove Identity observed→imported (origem autoritativa, marca verified) + acha/cria Bond(contract)/BondParticipant(imported). Person divergente → Pendency de reconciliação (nunca merge cego). Destrava o match de posse de canal. Ação de admin do tenant; auditável; re-rodável.',
        auditSeverity: 'high',
        category: 'identity',
        appliesTo: 'tenant',
    },
    // ─── Frente Vínculo/Contexto/Memória F2-a — estabelecer/evoluir vínculo ─
    // Operador estabelece o vínculo (Bond↔Person) que falta: cria/acha o Bond
    // + cria o participante com proveniência correta (avaliza titular →
    // operator_confirmed + verified). Genérico sobre bond.type; opt-in; Pro+.
    {
        code: 'customer-link-establish',
        tierMin: 'professional',
        description: 'Estabelecer/evoluir o vínculo (Bond) de uma pessoa numa conversa (F2-a): criar/achar o Bond do tipo apropriado + criar o BondParticipant que falta com a proveniência correta (avalização de titular pelo operador → operator_confirmed + Identity verificada-via-operador 90d; papel não-titular/menor confiança → self_declared, sem mexer em verified). Genérico sobre bond.type (patient_care/customer-account/contract/ vendor-relationship…). Fecha o 409 do confirm-link (que só promove participação existente). Ação de operador que opera a conversa.',
        auditSeverity: 'info',
        category: 'identity',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    // ─── Motor Neutro A3 — registro de ação declarativo (Porteiro Neutro) ──
    // Casa de config: tenant autora ação→categoria de risco (por tenant▸vertical,
    // sobre o seed de plataforma A2). preview/dry-run + portão de aprovação de
    // plataforma (retém rebaixamento de piso de LEITURA). 3 caps opt-in FORA de
    // pacote ⇒ merge inerte (DORMENTE + gated).
    {
        code: 'action-risk-category-read',
        tierMin: 'professional',
        description: 'Ler o mapeamento ação→categoria de risco do tenant + preview/dry-run do piso de identidade resultante (Porteiro Neutro A3). Governança de config; sem PII.',
        auditSeverity: 'info',
        category: 'admin',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    {
        code: 'action-risk-category-author',
        tierMin: 'professional',
        description: 'Criar/editar/remover override de categoria de risco de ação (Porteiro Neutro A3). approvalStatus é SERVER-DERIVED (classifyMappingRisk): um rebaixamento de piso de LEITURA nasce pending_platform_review (retido até aprovação de plataforma). Audit high (toca a semântica do piso de identidade).',
        auditSeverity: 'high',
        category: 'admin',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    {
        code: 'action-risk-category-platform-approve',
        tierMin: 'professional',
        description: 'Aprovar um override retido em pending_platform_review (rebaixamento de piso de LEITURA) — governança do PISO de plataforma (mitigação do residual da Decisão 2). Em produção seria papel de PLATAFORMA (super-admin cross-tenant, inexistente hoje) — opt-in + audit high deixam explícito. Audit high.',
        auditSeverity: 'high',
        category: 'admin',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    // ─── Motor Neutro B1 — grafo de vínculo N-papéis-por-instância ──
    // Preview read-only do grafo de papéis por-instância (papéis-domínio distintos
    // + emRelaçãoA do bond.type + preview do direito de ação por papel). DORMENTE:
    // o gate NÃO consome o grafo. Cap opt-in FORA de pacote ⇒ merge inerte.
    {
        code: 'role-graph-read',
        tierMin: 'professional',
        description: 'Ler o grafo de vínculo por-instância de um Bond (papéis-domínio distintos + emRelaçãoA + preview do direito de ação por papel) — Motor Neutro B1. Read-only; DORMENTE (não muda o gate). Governança de config; sem PII além do já-autorizado.',
        auditSeverity: 'info',
        category: 'admin',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    // ─── Motor Neutro B2 — autoridade de decisão + wire Guardianship ──
    // Preview read-only dos vereditos de autoridade (self/substitute/supported)
    // entre os participantes de um Bond. DORMENTE: o gate NÃO consome. Cap opt-in
    // FORA de pacote ⇒ merge inerte.
    {
        code: 'decision-authority-read',
        tierMin: 'professional',
        description: 'Ler os vereditos de autoridade de decisão (self/substitute/supported) entre os participantes de um Bond — Motor Neutro B2 (wire read-only do Guardianship). Read-only; DORMENTE (não muda o gate). Dado sensível (guardianship/capacidade); sem PII além do já-autorizado; tenant-scoped.',
        auditSeverity: 'info',
        category: 'admin',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    // ─── Motor Neutro B4 — visibilidade por papel×contraparte ──
    // Preview read-only da compartimentação de audiência de um Bond (compartimento
    // por participante — N códigos derivados do papel POR-INSTÂNCIA, não as 2 facções
    // cravadas — + matriz papel × audiência). DORMENTE: o filtro vivo NÃO consome.
    // Cap opt-in FORA de pacote ⇒ merge inerte.
    {
        code: 'visibility-graph-read',
        tierMin: 'professional',
        description: 'Ler a compartimentação de audiência de um Bond (compartimento por participante + matriz papel × audiência) — Motor Neutro B4. Read-only; DORMENTE (não muda o filtro de visibilidade vivo). Governança de config; sem PII além do já-autorizado; tenant-scoped.',
        auditSeverity: 'info',
        category: 'admin',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    // ─── Motor Neutro B4b — autoria da policy de compartimentação ──
    // Declara `Bond.metadata.visibilityPolicy` (papel de vínculo → compartimento).
    // O portão rejeita código reservado ou cunhado pela plataforma (config só cunha
    // códigos NOVOS) e audita HIGH o remapeamento. Cap opt-in FORA de pacote.
    {
        code: 'visibility-policy-manage',
        tierMin: 'professional',
        description: 'Declarar a policy de compartimentação de audiência de um Bond (papel de vínculo → compartimento) — Motor Neutro B4b. Governa quem VÊ o quê dentro do vínculo; o piso de plataforma impede ampliação (config só cunha compartimentos novos, nunca entra num cunhado pela plataforma). PUT idempotente; tenant-scoped; audit sem PII.',
        auditSeverity: 'high',
        category: 'admin',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    // ─── Motor Neutro B4c — abrir/fechar o CAUCUS da conversa ──
    // O writer que nunca existiu: `Conversation.sessionContext` tinha ZERO writers em
    // `src` e nem chegava ao wire. Compartimento OPACO cunhado pelo vínculo (N partes).
    // Muda quem LÊ a conversa ⇒ audit SEMPRE high. Cap opt-in FORA de pacote.
    {
        code: 'conversation-caucus-manage',
        tierMin: 'professional',
        description: 'Abrir e fechar o caucus de uma conversa — a sessão confidencial restrita a um compartimento de audiência do vínculo (Motor Neutro B4c). Governa quem passa a ler a conversa; o piso de plataforma impede código reservado ou do vocabulário de sessão aberta. PUT idempotente; tenant-scoped; audit high sem PII.',
        auditSeverity: 'high',
        category: 'admin',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    // ─── Motor Neutro B3 — taxonomia de prazos com polaridade ──
    // Preview read-only: quais prazos correm sobre o tenant, o que acontece quando cada um
    // vence (perde o direito / acumula violação / bloqueia até decorrer), o valor
    // declarado onde é declarável, e quais não têm motor. DORMENTE: a primitiva não
    // é consumida no caminho quente. Cap opt-in FORA de pacote ⇒ merge inerte.
    {
        code: 'deadline-taxonomy-read',
        tierMin: 'professional',
        description: 'Ler a taxonomia de prazos em vigor no tenant — a polaridade de cada prazo (o que acontece quando vence: perde o direito / acumula violação / bloqueia até decorrer), o valor declarado onde é declarável, e quais prazos não têm motor hoje. Motor Neutro B3. Read-only; DORMENTE (não muda conduta); sem PII; tenant-scoped.',
        auditSeverity: 'info',
        category: 'admin',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    // ─── Motor Neutro B2c — auto-restrição tipada (escopo + termo + revogabilidade) ──
    // Generaliza as 2 auto-restrições que já viviam ad-hoc no motor (o STOP perpétuo e sem
    // escopo, e a oposição LGPD tudo-ou-nada). O registro é APPEND-ONLY e uma restrição
    // irrevogável NÃO se revoga antes do termo — nem pela plataforma ⇒ audit SEMPRE high.
    // Caps opt-in FORA de pacote ⇒ merge inerte.
    {
        code: 'self-restriction-declare',
        tierMin: 'professional',
        description: 'Declarar e revogar auto-restrição tipada de uma pessoa — o que está restrito (escopo), até quando (termo) e quem pode desfazer (revogabilidade) — Motor Neutro B2c. Registro APPEND-ONLY: escopo e termo são imutáveis (não há edição), e uma restrição irrevogável não se revoga antes do termo, nem pela plataforma. Enforçada no chokepoint do disparo proativo. Tenant-scoped; audit high sem PII.',
        auditSeverity: 'high',
        category: 'admin',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    {
        code: 'self-restriction-read',
        tierMin: 'professional',
        description: 'Ler as auto-restrições de uma pessoa e a disposição resolvida de cada uma (em vigor / termo decorrido), mais o estado das auto-restrições ad-hoc pré-existentes (opt-out STOP e oposição LGPD) — Motor Neutro B2c. Read-only, tenant-scoped, sem PII além do já autorizado.',
        auditSeverity: 'info',
        category: 'admin',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    // ─── Motor Neutro B5 + D1 — preview IAL×AAL da identidade ─────────────────
    // Os 2 eixos ORTOGONAIS que a B5 separou (proofing «quem é» × mecanismo «como se
    // autenticou»), ancoragem no canal, o nível legado que o gate lê hoje, e o
    // veredito ação-por-ação nos DOIS lados do flip da flag. Read-only, não decide
    // nada e funciona com a flag OFF — é a superfície que transforma a prova
    // DB-backed da B5 em observável. Cap opt-in FORA de pacote ⇒ merge inerte.
    {
        code: 'identity-assurance-read',
        tierMin: 'professional',
        description: 'Ler o preview IAL×AAL de uma identidade — os dois eixos ORTOGONAIS que a B5 separou (proofing «quem é» × mecanismo «como se autenticou»), se a identidade está ANCORADA no canal, o nível legado que o gate lê hoje, e o veredito ação-por-ação nos DOIS lados do flip da flag `LUME_IDENTITY_AAL_ENABLED`. Motor Neutro B5 + D1. Read-only, tenant-scoped, NÃO decide nada e não escreve nada; funciona com a flag OFF (é assim que o eixo se valida contra dado real ANTES de ligar). Sem PII: devolve as colunas de verificação da identidade (verified/provenance/verifiedVia/datas), nunca identificador de canal nem nome.',
        auditSeverity: 'info',
        category: 'admin',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    // ─── Espera Viva PR-4 (03/Ago/2026) — Fatos Operacionais ─────────────────
    // Eventos que afetam atendimentos em espera (spec §2.6): supervisor registra/
    // resolve; a IA retoma proativamente as conversas em espera afetadas. Cap
    // opt-in FORA de pacote ⇒ merge inerte; ativação = decisão do TL.
    {
        code: 'operational-facts-manage',
        tierMin: 'team',
        description: 'Registrar, listar e resolver Fatos Operacionais — eventos que afetam atendimentos em espera (Espera Viva §2.6). Ao registrar, a IA retoma proativamente as conversas em espera afetadas com fala determinística (moldura neutra + summary do fato); na resolução, avisa quem foi noticiado. Vocabulário (kind/scope/summary) é do TENANT — o motor só conhece «fato com escopo». Fontes: manual (REST), internal (evento) e mcp (sync gated — o conector precisa anunciar operational-status-check).',
        auditSeverity: 'warning',
        category: 'admin',
        appliesTo: 'tenant',
        optInRequired: true,
    },
    // ─── Conversas Cliente-Cêntricas B1 (12/Ago/2026) — Inbox por pessoa ─────
    // Inbox agrupada por PESSOA (spec 2026-08-12 §3.3) — apresentação pura;
    // sem a cap a lista renderiza como hoje (1 card por conversa). Cap opt-in
    // FORA de pacote ⇒ merge inerte; ativação = decisão do TL.
    {
        code: 'inbox-person-grouping',
        tierMin: 'solo',
        description: 'Agrupar a listagem de conversas (Inbox web e mobile) por pessoa: 1 card por cliente em cada seção, com as conversas ativas do cliente dentro do grupo e link ao histórico (ficha). Apresentação pura — sem a cap, a lista renderiza exatamente como hoje (1 card por conversa). Sinais por conversa (P0/P1, não-entregue, IA segurando, hora) preservados.',
        auditSeverity: 'info',
        category: 'coordination',
        appliesTo: 'user',
        optInRequired: true,
    },
    // ─── Conversas Cliente-Cêntricas Alvo B round2 (12/Ago/2026) ─────────────
    // Default de ordenação da Inbox por recência (só o default; ?sort= vence).
    // Cap opt-in FORA de pacote => merge inerte; ativação = decisão do TL.
    {
        code: 'inbox-recency-default',
        tierMin: 'solo',
        description: 'Ordenação default da Inbox por «Mais recentes» (recência) em vez de «Urgência (Conflict+SLA)». Só muda o DEFAULT — o seletor continua oferecendo ambas e `?sort=` explícito na URL sempre vence. Sem a cap, default histórico (urgency) byte-idêntico.',
        auditSeverity: 'info',
        category: 'coordination',
        appliesTo: 'user',
        optInRequired: true,
    },
    // ─── Conversas Cliente-Cêntricas B2 (12/Ago/2026) — transcript contínuo ──
    // O scroll atravessa conversas da MESMA pessoa (cada uma re-autorizada;
    // caucus/bond adversarial FORA). Gate duplo: cap ∧ flag. Cap opt-in FORA
    // de pacote ⇒ merge inerte; ativação = decisão do TL.
    {
        code: 'person-transcript-read',
        tierMin: 'solo',
        description: 'Ler o transcript contínuo por pessoa na Conversa em curso (GET /conversations/:id/messages?personScope=true): o cursor atravessa conversas anteriores da MESMA pessoa com divisória de episódio. Regras duras no servidor: cada conversa do escopo é re-autorizada (nunca contorna ACL); sessionCompartment (caucus) fica fora; bond com adversarialMode != none fica fora; sem escopo aplicável degrada para a conversa única (meta.personScope=false — regra do silêncio, nunca 403).',
        auditSeverity: 'info',
        category: 'conversation',
        appliesTo: 'user',
        optInRequired: true,
    },
    // ─── Localizador Universal (⌘K), 14/Ago/2026 — busca de conteúdo ─────────
    // Atravessa PESSOAS, diferente de person-transcript-read (que já tem a
    // pessoa escolhida): pode revelar que EXISTE mensagem numa conversa que o
    // caller nunca abriria. Exposição diferente ⇒ capability própria. Opt-in
    // FORA de pacote ⇒ merge inerte; ativação = decisão do TL.
    {
        code: 'message-content-search',
        tierMin: 'solo',
        description: 'Buscar por conteúdo de mensagem em todo o tenant, atravessando pessoas (GET /v1/messages-search?q=). Serve o caso em que o operador não lembra nome nem telefone e só lembra algo que foi dito. Regras duras no servidor: o escopo é re-autorizado conversa a conversa (nunca contorna ACL); a peneira adversarial roda com over-fetch para não devolver menos que o pedido; termo com menos de 3 caracteres é recusado (abaixo disso o índice trigram não cobre e a consulta volta a seq scan); sem a capability degrada para { data: [], meta: { enabled: false } } — regra do silêncio, nunca 403.',
        auditSeverity: 'info',
        category: 'conversation',
        appliesTo: 'user',
        optInRequired: true,
    },
];
export const CAPABILITY_CODES = CAPABILITY_CATALOG.map((c) => c.code);
export function findCapability(code) {
    const found = CAPABILITY_CATALOG.find((c) => c.code === code);
    if (!found) {
        throw new Error(`Capability code '${code}' não encontrada no catálogo`);
    }
    return found;
}
//# sourceMappingURL=catalog.js.map